import VI from './VI';

export default {
  quickActions: 'Quick Actions',
  servers: {
    name: 'Server',
    auto: 'Automatic',
    vietnam: 'Vietnam',
    singapore: 'Singapore',
    main: 'Main',
    reserve: 'Reserve'
  },
  boss: 'Boss',
  cart: 'Cart',
  line: 'Line',
  gotit: 'I got it!',
  timezone: 'Timezone',
  timezoneHint: 'Updating the timezone may change the reported data',
  download: 'Download',
  collapse: 'Collapse',
  expand: 'Expand',
  salesman: 'Salesperson',
  sort: 'Sort',
  appNotAvailable: 'This app is not available. Please try again later!',
  getStart: 'Get Started',
  itemPerPage: 'Quantity per page',
  takeAway: 'Take away',
  printBill: 'Print Invoice',
  barcodeText: 'Code (text)',
  now: 'Now',
  hour: 'hours',
  minutes: 'minutes',
  second: 'seconds',
  limitFeatureForFree: 'This feature is only available in the Premium version. Please upgrade to use it!',
  orderIsPaying: 'Order is paying',
  canUpdateOrder: 'Are you sure to cancel? Changes will not be updated!',
  charge: 'Checkout',
  checkout: 'Checkout',
  commingSoon: 'Not available yet',
  upcoming: 'Upcoming',
  notActive: 'Not active',
  hidden: 'Hidden',
  content: 'Content',
  close: 'Close',
  showing: 'Showing',
  addShortCut: 'Add shortcut',
  billUIChoice: 'Choose invoice interface',
  qrUIChoice: 'Select QR code interface',
  devicePermissionDenied: 'You need to grant permission for the application to perform this feature!',
  permissionNotifyInfo: 'You need to grant notification permission for this feature to work!',
  oldVersion: 'Previous Version',
  changeText: 'Change',
  value: 'Value',
  confirmDelete: 'Are you sure you want to delete this?',
  choiceProductUnitConvertWarning: 'Please select the unit of the product',
  deprecated: 'Deprecated',
  saving: 'Saving',
  active: 'Activate',
  featureUnderDev: 'This function is being completed. Please come back later!!',
  spending: 'Spending',
  overview: 'Overview',
  recommend: 'Recommended',
  savePdf: 'Save as PDF',
  bankQR: 'Bank QR code',
  quantityInvalid: 'Invalid quantity',
  returnToHome: 'Return to home screen',
  forever: 'Lifetime',
  expired: 'Expired',
  expiredShort: 'Expired',
  barcodeTable: 'Product barcode table',
  price: 'Price',
  copied: 'Copied to clipboard!',
  autoGen: 'Auto-generate',
  check: 'Check',
  signature: 'Signature',
  permission: 'Permission',
  staffLogin: 'Staff Login',
  staffSale: 'Sales Staff',
  updateInfo: 'Update Profile',
  staffPermission: {
    title: 'Employee Permissions',
    detail: 'Decentralize permissions for employees to use directly on the management WEB/APP. Employee-only Apps may not have some of these functions',
    allOrderType: 'Sales order, import, return',
    showRevenue: 'Show profit in orders',
    financial: 'Receipt and expenditure slip',
    showAllCustomer: 'Show all customers',
    showAllCustomerDetail: 'Access to all customers not created by this employee',
    editPrice: 'Allow editing of selling price',
    editPriceDetail: 'Allow staff to edit selling price during sale. Otherwise product will be sold at retail price.',
    showAllOrder: 'Show all orders',
    showAllOrderDetail: 'Show all orders of managers and other employees',
    canViewFinancialStats: 'View cash flow',
    canViewFinancialStatsDetail: 'Allow employees to view their cash flow reports',
    canViewDebtStats: 'View debts',
    canViewDebtStatsDetail: 'View debts of the entire store',
    canViewWarehouseStats: 'View inventory reports',
    canViewWarehouseStatsDetail: 'View inventory status reports',
    canViewSalesStats: 'View sales reports',
    canViewSalesStatsDetail: 'View total sales reports of the entire store',
    canExportEInvoice: 'Export e-invoice',
    canExportEInvoiceDetail: 'Staff can export e-invoices',
    roleAndAccess: 'Role & Access',
    roleAndAccessSubtitle: 'Configure role and warehouse access for staff',
    role: 'Role',
    roleManager: 'Manager',
    roleRegular: 'Regular Staff',
    warehouseAccess: 'Warehouse Access',
    allWarehouses: 'All Warehouses',
    selectWarehouses: 'Select accessible warehouses:',
    warehouseAccessDenied: 'You do not have permission to access this warehouse',
    managerNote: 'Manager has all permissions except updating shop account and managing staff.',
    dataOperation: 'Data Operation Permissions',
    featuresAndStats: 'View & Feature Permissions'
  },
  renew: 'Purchase Now',
  updatedAt: 'Updated at',
  saveDraft: 'Save Draft',
  buy: 'Purchase',
  birthday: 'Birthday',
  barcodeNotFound: 'This barcode was not found!',
  saved: 'Saved',
  saveImage: 'Save image',
  next: 'Next',
  reality: 'Reality',
  difference: 'Difference',
  hide: 'Hide',
  editComponent: 'Customize Appearance',
  amount: 'Amount',
  search: 'Search',
  simple: 'Simple',
  more: 'More',
  share: 'Share',
  inventoryDelivery: 'Delivery Note',
  type: 'Type',
  transactionHistory: 'Transaction history',
  blanceAndDebt: 'Balance/Outstanding Debt',
  limitWarning: 'Your account is restricted due to repeated refunds. If more than 3 times, the account will be permanently locked and cannot recover data. Thank you!',
  upgradePro: 'Upgrade',
  iapSupport: '',
  emptyData: 'No data',
  seemore: 'See More',
  version: 'Version',
  financialIn30days: 'Financial in the last 30 days',
  financialInMonth: 'Finances this month',
  orFastLoginWith: 'Fast login with Google, Apple account',
  fontSize: 'Font size',
  changeFontSizeWarning: 'The font size has been changed. You should exit the application and restart it for the app to work stably',
  fontSizeList: ['Very Small', 'Small', 'Medium', 'Large', 'Very large', 'Very very large'],
  contact: 'Contacts',
  cause: 'Reason',
  default: 'Default',
  manager: 'Manager',
  paymentMethod: 'Payment Method',
  closeWarning: 'Are you sure you want to turn this feature off?',
  paymentMethodList: ['Cash', 'Bank transfer', 'Debit'],
  printerVideoDemo: 'Connection instruction video',
  supportWarning: 'If you need support, please contact the Facebook channel for the development team. Thank you for your support!',
  offlineWarning: 'You are using offline. You should register an account to use online to avoid data loss and can use many other features as well as can use the desktop version.',
  updating: 'Updating',
  loadingData: 'Preparing data',
  loadingHint: 'System is processing, please wait a moment...',
  remain: 'Remaining',
  choiceProductTypeWarning: 'Please select a product category',
  editProduct: 'Edit Merchandise',
  onlyOnlineSupport: 'The feature only supports online. Please login account to use this feature!',
  createBy: 'Created by',
  userName: 'Username',
  fullName: 'Full Name',
  webVersion: 'Web version (PC)',
  webVersionBackup: 'Alternate Link',
  syncingProgress: "Sync is in progress. Please wait 1 - 15 minutes. We'll send you an email when the process is complete",
  bulkDelete: 'Bulk Delete',
  sync: 'Sync',
  offline: 'Offline',
  offlineNotSupport: 'Offline not supported',
  warning: 'Warning',
  back: 'Back',
  yes: 'Yes',
  no: 'No',
  refresh: 'Refresh',
  home: 'Home',
  quantity: 'Quantity',
  tryAgain: 'Try again',
  language: 'Language',
  theme: 'Theme',
  dark: 'Dark',
  light: 'Light',
  total: 'Total',
  totalMoney: 'Total amount',
  paid: 'Paid',
  totalDebit: 'Total arrears',
  totalOldDebit: 'Old debt',
  totalReminder: 'Total Remaining',
  totalOldReminder: 'Old remainder',
  oldPrint: 'Print Invoice (Simple)',
  debit: 'Arrears',
  remainder: 'Remainder',
  arrears: 'Arrears',
  status: 'Status',
  add: 'Add',
  create: 'Create',
  save: 'Save',
  print: 'Print',
  export: 'Export Invoice',
  copy: 'Copy',
  edit: 'Edit',
  delete: 'Delete',
  update: 'Update',
  updateStatus: 'Update status',
  day: 'Day',
  month: 'Month',
  year: 'Year',
  from: 'From',
  to: 'To',
  fromDate: 'From date',
  toDate: 'To date',
  choiceImage: 'Choice image',
  exist: 'exist',
  invalidParams: 'Please enter enough data',
  success: 'Success',
  fail: 'Failed',
  all: 'All',
  complete: 'Complete',
  pending: 'Pending',
  canceled: 'Canceled',
  cancel: 'Cancel',
  ok: 'OK',
  or: 'or',
  choice: 'Choice',
  confirm: 'Confirm',
  confirmExitApp: 'Would you want to exit app?',
  time: 'Time',
  notFound: 'Data not found! Please try again!',
  createdAt: 'Created at',
  none: 'None',
  detail: 'Detail',
  filter: 'Filter',
  filterByTim: 'Filter by date',
  note: 'Note',
  trial: 'Trial',
  option: 'Option',
  notify: 'Notify',
  understand: 'I understand',
  exportToExcel: 'Excel Export',
  multiHidden: 'Bulk Hide',
  multiActive: 'Batch activation',
  hiddenList: 'Hidden Items',
  showList: 'Active Items',
  importDataFromExcel: 'Import from Excel',
  describe: 'Description',
  addImage: 'Add image',
  limitUpload: 'Up to 5 images per product',
  sorryText:
    'Hello!\n Yesterday the developer released a new update. Because the testing process is not careful, it causes the error of losing all the inventory in stock. The developer is really sorry for this. Please re-enter the quantity in the product details 😢 . Sorry you lot! Wish you sympathize!',
  limitFeature: {
    intro: 'You can experience it for free. And pay when you really need it',
    free: 'Free version',
    pro: 'Premium (paid) version',
    title: 'You need to purchase the premium version to use this feature',
    package: 'Premium packages',
    packageOther: 'Other service packages',
    features: [
      'No ads',
      'Unlimited products creation (Free version limited to 100 products)',
      'Unlimited orders',
      'Unlimited printing or issuing invoices',
      'Product barcode printing feature (on web version)',
      'Point accumulation feature for customers',
      'Order copy feature',
      'Merchant payable surcharge feature',
      'Return feature',
      'Hide old products feature',
      'Product classification feature (Example: Jeans product has size classification M, L, XL)',
      'Feature to import and export data to Excel file',
      'Feature for adding receipts and payments',
      'Feature to add old debt slips to customers',
      'Feature to create delivery notes',
      'Feature to create QR codes to pay directly for orders',
      'Draft order feature (create orders without network connection)',
      'Unlimited use of web version (Desktop)'
    ],
    freeFeatures: [
      'Does display ads',
      'Limit 100 products',
      'Limit 2.000 orders',
      'Limit feature to hide old products',
      'Limit merchant surcharge features',
      'Limit return feature',
      'Limited barcode printing feature',
      'Limited customer point accumulation feature',
      'Limited commodity classification features',
      'Limit printing or exporting invoices',
      'Limit export to excel',
      'Limit the feature of adding receipts and payments',
      'Limit the feature of adding debt notes',
      'Limit the ability to import products and customers from excel files',
      'Limit the ability to create delivery notes',
      'Limited payment QR code creation feature',
      'Free 3 months of web version'
    ]
  },
  syncDetail: {
    text1: 'Sync data from your device to your account. This process only needs to be done once. ',
    text2: 'Each account can only sync once successfully',
    text3: 'This function is still being in too a test. If you encounter an error, please respond to the developer for support as soon as possible. ',
    start: 'Start sync',
    feedback: 'Feedback to the developer',
    sendErrorData: 'Send error data',
    sure: 'Are you sure you want to sync data with this account?',
    syncedError: 'This account has been a clocked and',
    syncedAlert: 'This account of you are not dong data offline. Do you want to sync now? '
  },
  account: {
    systemSmartSubtitle: 'Smart Sales Management System',
    switch: 'Switch account',
    switchConfirm: 'Are you sure you want to switch to account %s?',
    switchDeleteConfirm: 'Are you sure you want to delete the login session of account %s?',
    requiredInfo: 'Please enter all required information',
    enterCodeRequired: 'Please enter the verification code',
    enterPasswordRequired: 'Please enter both password fields',
    passwordNotMatch: 'The two passwords do not match',
    loginSubtitle: 'Welcome back to our platform!',
    registerSubtitle: 'Join us today and explore!',
    noAccountYet: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    forgotPasswordStepEmail: 'Enter your email to start your password recovery.',
    forgotPasswordStepCode: 'Please enter the 6-digit verification code sent to your email.',
    forgotPasswordStepPassword: 'Use a strong password to protect your account.',
    backToLogin: 'Back to Login',
    sendCodeSuccess: 'We sent an email with the code. Please check your email for the confirmation code',
    errorCode: 'Invalid confirmation code',
    codeExpired: 'The verification code has expired.',
    forgotPassword: 'Forgot Password',
    enterEmail: 'Enter your email',
    enterCode: 'Enter confirmation code',
    sendCode: 'Send confirmation code',
    submitCode: 'Confirm',
    changePassword: 'Change Password',
    newPassword: 'New Password',
    renewPassword: 'Reset new password',
    password: 'Password',
    repassword: 'Re-enter password',
    register: 'Register',
    inputSoShort: 'Username or password is too short',
    repassWrong: 'The re-entered password is incorrect',
    emailExist: 'Email already exists',
    logout: 'Logout',
    login: 'Login',
    offlineMode: 'Use offline',
    offlineModeWarning: 'When used offline, data will be saved on your device. You need to sign in before switching to another device without losing data',
    offlineDeprecated:
      'As of 13/3/2025. This application no longer supports offline functionality. \nTo use offline for free. Please download the aSeller Offline application (The application has an orange icon).\nThank you!',
    logoutConfirmMessage: 'Are you sure you want to sign out of this account?',
    notFoundEmail: 'Account not found with this email',
    errorPassword: 'Incorrect password',
    emailInvalid: 'Invalid email format',
    loginWithoutEmail: 'Login without email',
    loginWithoutEmailError: 'Error unable to generate device code. Please contact support for instructions!',
    titleRequest: 'We have received a request to change the password associated with this email.',
    enterCodeEmail: "Enter the verification code sent to your email. If you don't find it, please check your email client's spam or junk folder."
  },
  schedule: {
    title: 'Schedule Management',
    add: 'Add Schedule',
    requiredInfo: 'Please fill in all required information',
    updateError: 'Failed to update schedule',
    createError: 'Failed to create schedule',
    updateSuccess: 'Schedule updated successfully',
    createSuccess: 'New schedule created successfully',
    deleteError: 'Failed to delete schedule',
    deleteSuccess: 'Schedule deleted successfully',
    pending: 'Pending',
    completed: 'Completed',
    name: 'Name',
    value: 'Value',
    time: 'Time',
    status: 'Status',
    action: 'Action',
    edit: 'Edit',
    editTitle: 'Edit Schedule',
    createTitle: 'Create New Schedule',
    namePlaceholder: 'Enter schedule name',
    valuePlaceholder: 'Enter value',
    deleteTitle: 'Delete schedule',
    deleteConfirm: 'Are you sure you want to delete this schedule?'
  },
  statitical: {
    costOfCapital: 'Cost of capital',
    chart: 'Chart',
    title: 'Reports & Analytics',
    debtBook: 'Debit Book',
    sale: 'Sales',
    revenue1: 'Revenue',
    revenue: 'Profit',
    capital: 'Capital',
    profit: 'Profit',
    saleToday: 'Today',
    expense: 'Expense',
    returnOrderTitle: 'Return Order Statistics',
    sale7Days: '7 days',
    sale30Days: '30 days',
    chart7Days: 'Chart of the last 7 days',
    saleTitle: 'Sales statistics',
    revenueTitle: 'Profit statistics',
    orderTitle: 'Sales receipt statistics',
    order: 'Sales receipt',
    stock: 'Inventory Statistics',
    quantityOfInventory: 'Quantity of inventory by unit',
    quantityOfInventoryByCategory: 'Inventory by category',
    inventoryCapital: 'Inventory Capital',
    inventoryCapitalDetail: '(According to current input price)',
    quantityOfInventoryProduct: 'Most stocked product',
    saleOfStaff: 'Sales of employees',
    choiceToView: 'Please select a report type and time to view more detailed information',
    choiceType: 'Report type',
    oldStaticWarning: 'The report has updated data according to your time zone.'
  },
  menu: {
    category: 'Category',
    statitical: 'Reports & Analytics',
    oldStatitical: 'Statistical (old)',
    version: 'Version',
    other: 'Others',
    setting: 'Settings',
    orderReturn: 'Return Order',
    shortcut: 'Shortcut',
    account: 'My Account',
    feedback: 'Feedback & suggestions',
    share: 'Share this app to a friend',
    reportBug: 'Send data to report bugs',
    reportLogBug: 'Send log to report bugs',
    policy: 'Privacy Policy',
    term: 'Terms of Use',
    editProfile: 'Update information',
    editProfileDetail: 'Update store information so that it is fully displayed on the invoice.',
    support: 'Support'
  },
  settingForStaff: {
    branchHint: 'This entry is for Cafe & Restaurant business only',
    title: 'Store Settings',
    staff: 'Staff',
    staffApp: 'App for employees',
    branch: 'Area',
    cafe: 'Cafe & Restaurant',
    passForStaff: 'Staff password',
    passForStaffDetail: "Special password for employee login on sales application. Don't let it be the same as the master password",
    mainBranch: 'Main',
    addBranch: 'Add area',
    editBranch: 'Edit area',
    addStaff: 'Add employee',
    editStaff: 'Edit staff',
    table: 'Table',
    branchName: 'Area',
    branchTable: 'Number of tables',
    staffs: 'Staff management',
    emailExist: 'Email already exists',
    staffsDetail: 'Each store will get 1 months free for the first employee',
    addStaffSubtitle: 'Create a new staff account',
    editStaffSubtitle: 'Update staff account',
    accountInfo: 'Account Information',
    personalInfo: 'Personal Information',
    placeholderUserName: 'Username...',
    placeholderPasswordEdit: 'Leave blank if no change',
    placeholderPassword: 'Password...',
    placeholderFullName: 'Full name...',
    placeholderPhone: 'Phone...',
    placeholderAddress: 'Address...',
    placeholderNote: 'Note about staff...',
    emptyStaff: 'No staff yet.',
    upgradeStaff: 'Renew',
    appForStaffIntro:
      'Employee list app, your employees can use this app to create orders. You will need to create an employee account to use it. The data will be synced to your main account.',
    shopType: 'Business Type',
    grocery: 'Grocery, Supermarket',
    appForStaff: ['aSeller for Staff'],
    appForStaffDetail: ['Suitable for restaurant, cafe, tea, grocery, retail...'],
    shopTypeDetail: 'Choose the right business type to use the right interface on the sales application for employees',
    showCustomer: 'Show customers to employees',
    showCustomerDetail: 'Show customer list on employee app',
    customerShowMode: ['Show all', 'Employee guests only', 'Not visible'],
    upgradeStaffContact: '',
    service: 'Service',
    serviceDetail: 'Shop, cafe, milk tea, restaurant...',
    retail: 'Quick Sale',
    retailDetail: 'Grocery, supermarket...',
    showStatistial: 'Show weekly sales',
    showStatistialDetail: 'Allow employees to view sales for the last 7 days',
    uiForStaft: 'Sales interface for staff',
    uiForStaftDetail: "Choose the appropriate interface for your employees' convenience",
    typeCafe: 'There is a list of tables for convenient viewing. Suitable for business forms of restaurants, bars, shops, cafes, tea shops... ',
    typeRetail: 'Simple interface. Suitable for retail and wholesale, just need a simple but effective interface.',
    typeSalesCounter: 'Counter interface. Suitable for counter staff, professional and efficient',
    counter: 'Counter',
    stockEnabled: 'Show inventory to staff',
    stockEnabledDetail: 'Show inventory, sales on staff app',
    productList: 'Product List',
    productListDetail: 'Set the product list to display for each employee',
    tableManager: 'Table Order'
  },
  prefix: {
    title: 'Prefix',
    detail: 'The string of characters appearing before the code of the order, product,... eg order code: HD123'
  },
  setting: {
    advanced: 'Advanced',
    customerCanRegister: 'Allow customers to register for an account',
    customerCanRegisterDetail: 'Customers can register for an account themselves. Customers can track their orders, invoices.',
    vote: 'Vote this app!',
    about: 'About',
    title: 'General',
    help: 'You need help?',
    currency: 'Currency unit',
    timeFormat: 'Date format',
    oddNumber: 'Show odd numbers',
    oddNumberEx: 'Ex $100.15, 0.5KG...',
    sync: 'Synchronized',
    login: 'Login',
    logout: 'Logout',
    notSignin: 'Not signed in',
    syncIntro: 'Sign in to your Google account for backups to keep your data safe and transferable',
    syncNow: 'Backup now',
    lastSync: 'Last backup at',
    restore: 'Restore',
    requireLogin: 'You need to be logged into your Google account to perform this function',
    syncNotFound: 'No backup found',
    confirmSync: 'Data on the server will be overwritten. Are you sure you want to backup data?',
    confirmRestore: 'Are you sure you want to recover data, current data will be overwritten?',
    loginExpired: 'Login session expired. Please log in again!',
    autoBackup: 'Auto backup data',
    googleAccountConnect: 'Your Google account',
    on: 'On',
    off: 'Off',
    googleLogoutConfirm: 'Are you sure you want to logout this Google account??',
    print: 'Printer connection',
    printDetail: 'Select your bluetooth printer to connect and print the invoice of the product',
    connectPrinter: 'Printer',
    invoice: 'Invoice',
    invoiceHello: 'Invoice thank you message',
    surchargeText: 'Change the word surcharge on the bill',
    invoiceSignature: 'Display signature',
    invoiceDebt: 'Display debt',
    invoiceDebtInfo: 'Display outstanding balance in order details, bill, invoice',
    debt: 'Debt',
    invoiceDebtDetail: 'Detailed debit',
    invoiceDebtDetailDetail: 'Show item details in debit note',
    invoiceDiscount: 'Display discount',
    invoiceHelloDetail: 'Change the thank you note to the customer below the invoice',
    warningOutStock: 'Warning out of stock',
    warningOutStockDetail: 'Once out of stock, the order cannot be added',
    warningOutStockMessage: 'Your product is out of stock. Please enter more or disable this warning in settings',
    showRevenue: 'Show profit',
    orderStatus: 'Show order status',
    orderStatusDetail: 'Show status "Pending" or "Completed". If enabled, it will not be possible to generate a receipt for the order.',
    showHomeRevenue: 'Show profit',
    showHomeChart: 'Show chart',
    showHomeFinancial: 'Show finances',
    showHomeStatistial: 'Show statistics',
    averageBuyPrice: 'Average import price',
    averageBuyPriceDetail:
      'Import price is automatically averaged after each import to calculate profits more accurately.\nFormula = (Current inventory total + New inventory amount)/(Total quantity)',
    bankInfo: 'Bank account',
    vietQRCode: 'Payment QR Code (Vietnam Only)',
    vietQRCodeDetail: 'Scan VietQR code for quick payment. This includes information about the order amount and transfer content.',
    vietQRCodeWarning: 'Please enter correct account information. We will not be responsible if your information is entered incorrectly!',
    bankName: 'Bank name',
    bankAcc: 'Account number',
    bankAccName: 'Account holder name',
    bankTransferContent: 'Transfer content',
    showSurchargeShopPay: 'Show surcharges paid by the seller',
    showSurchargeShopPayDetail: 'If not selected, the surcharge paid by the seller will not be displayed on the bill or invoice',
    debtActive: 'Activate debt balance',
    debtActiveDetail:
      'Activate debt to track debt for customers. If you turn off debt-related functions (eg: order receipts, customer receipts, debit books...) they will not work.',
    debtInactiveDetail: 'Debt functionality has been disabled. To activate, please go to "Settings" -> "Order settings" -> "Activate outstanding balance"',
    inventoryActive: 'Activate inventory tracking',
    inventoryActiveDetail:
      'Track the amount of inventory in the warehouse. If turned off, all features related to inventory will not work.\nIf you run a service business such as a cafe, restaurant... you should turn off this function to simplify use.',
    inventoryInactiveDetail: 'This feature is inactive when inventory tracking is disabled. To activate, please go to "Settings" -> "Products settings" -> "Activate inventory".',
    inventoryActiveWarning: 'If you disable it, all inventory-related functions will not work. Are you sure you want to deactivate?'
  },
  customer: {
    id: 'Id',
    prefix: 'Customers id prefix',
    title: 'Customers',
    create: 'Create customer',
    name: 'Name',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    add: 'Create customer',
    choice: 'Choice customer',
    invalidPhoneOrAddress: 'Please enter your phone number or address',
    phoneExist: 'This phone number already exists',
    search: 'Filter by id, name, or phone number',
    free: 'Guest',
    freeDetail: 'Walk-in guest',
    orderStatistics: 'order Statistics',
    exportDebt: 'Export debt',
    addDebt: 'Add Debt',
    yearOld: 'Year old',
    countBirthDay: '%s days remaining',
    taxCode: 'Tax Code',
    citizenId: 'Identification Code',
    exportOrderExcel: 'Export Excel list of orders',
    taxCodeHint: 'Can search for organization by tax code',
    purchasedProducts: 'Purchased products',
    createScreen: {
      taxCodeNotFound: 'Tax code information not found',
      avatarLabel: 'Profile image',
      contactHint: 'Quickly fill customer info from contacts or add a profile image',
      basicInfoTitle: 'Basic information'
    },
    deleteWarning: 'Are you sure you want to delete this customer? All orders, receipts related to this customer will be changed to walk-in guest.'
  },
  order: {
    lastPrice: 'Last price',
    lastPriceAuto: 'Automatically use last sold price',
    lastPriceAutoDetail: 'Orders for a customer will automatically use the last price sold to that customer instead of the retail price',
    addDisplayInfo: 'Add display info',
    editDeadline: 'Order editing deadline',
    editDeadlineDetail: 'Allow orders to be edited within this number of days from their creation date.',
    editDeadlineExpired: 'Order has passed its editing deadline. Please update allowed order editing period in "Settings" -> "Order settings".',
    summary: 'ORDER SUMMARY',
    id: 'Id',
    prefix: 'Sales receipt id prefix',
    title: 'Sales receipt',
    create: 'Create sales receipt',
    edit: 'Edit sales receipt',
    detail: 'Order info',
    exportInvoice: 'Sales Invoice',
    add: 'Add products',
    realPrice: 'Real price',
    infoShop: 'Shop information',
    invalidCustomer: 'Please select or create a customer',
    invalidProduct: 'No products in the order',
    confirmDelete: 'You are sure to delete this %?',
    search: 'Filter by order id, name or customer phone number',
    discount: 'Discount',
    discount1: 'Discount',
    inStockNotEnough: 'Quantity products in stock are not enough. Please import more products or update quantity in stock.',
    createFailed: 'Failed to create order. Please try again or feedback to development',
    surcharge: 'Surcharge',
    surchargeDetail: '(ship, tax...)',
    barcodeNotFound: 'The product already exists. Please check the name or barcode code',
    price: 'Price',
    customPrice: 'Custom price',
    customPrice1: 'Discount by %',
    orderMoneyUpdated: 'The money of the order is updated again due to the price change',
    totalProductMoney: 'Total amount of products',
    totalMustPaidMoney: 'Total amount to pay',
    totalPaidMoney: 'Customer pays',
    totalDebtMoney: 'Total amount owed',
    paid: 'Paid',
    totalLiabilities: 'Total Liabilities',
    totalMustPaidMoneyForCustomer: 'Total must be returned to the customer',
    totalPaidMoneyForCustomer: 'Return to customer',
    providerRefunds: 'Supplier returns',
    providerDebt: 'Debt owed to supplier',
    pointDiscount: 'Deduct accumulated points',
    money: 'Total order amount',
    statusOffRequire: 'Turn off order status',
    statusOffRequireDetail:
      'To create a receipt for an order. You must turn off order status because it can cause confusion when it comes to the outstanding balance of the order. Are you sure you want to disable order status to use this function?',
    surchargeType2: 'Seller pays',
    surchargeType1: 'Buyer pays',
    surchargeTypeHint:
      "- Buyer pays: Will be included in order amount, included in revenue, not included in profit.\n- Seller paid: Will not be included in order amount, will create a corresponding payment voucher to include store's expenses",
    table: 'Table',
    changeTable: 'Change Table',
    changeTableInput: 'Enter the number of tables to change',
    separate: 'Separate',
    separateDetail: 'Split a single product into multiple lines within the same sales order.',
    promotionAuto: 'Automatically apply promotion',
    promotionAutoDetail: 'Automatically apply the promotion you selected most recently to the order',
    emptyProduct: 'Please add an item',
    draftOrderWarning: 'Note: This is a temporary invoice, not yet saved in the data.',
    draftSaved: 'Draft saved. Please check the draft list on "Home"',
    vatDetail: 'Tax(VAT) is automatically calculated from the VAT of the products',
    productSorting: 'Sort items in the order',
    productSortingDetail: 'Products added later will be displayed at the bottom of the list. Deactivate to display at the top of the list',
    description: 'Manage and track all your sales orders.'
  },
  product: {
    multiStopSale: 'Bulk stop selling',
    multiSale: 'Bulk sell products',
    stopSale: 'Stop selling',
    sale: 'Sell',
    stopSaleList: 'Stopped selling list',
    saleList: 'Selling list',
    product: 'Products',
    id: 'Id',
    prefix: 'Products id prefix',
    title: 'Products',
    create: 'Create product',
    add: 'Add product',
    choice: 'Choice product',
    name: 'Product name',
    priceType: 'Price type',
    price: 'Product price',
    buyPrice: 'Purchase price',
    sellPrice: 'Selling price',
    sellPrice1: 'Promotional price',
    sellPrice2: 'Wholesale price',
    inStock: 'In Stock',
    initStock: 'Initial quantity',
    initStockDetail: 'Initial stock quantity when creating a new product',
    vatDetail: 'Tax is calculated on the sale order',
    vat: 'Tax',
    recent: 'Recently added products',
    search: 'Filter by id, name',
    sold: 'Sold',
    outOfStock: 'Out of stock',
    expirationDate: 'Expiration date',
    enterQuantity: 'Enter quantity',
    barcode: 'Barcode',
    exist: 'The product already exists. Please check the name or barcode.',
    canNotDelete: 'Can not remove this product because it is already in the order. Please delete your order first.',
    errorPrice: 'The price you entered is not valid',
    changeSellPriceWarning: 'Note: Change sell price will affect existing orders',
    changeSellPriceWarningDetail: 'Price changes will affect existing orders, you will have to update the order containing this item. Are you sure you want to do this?',
    deleteNumProduct: 'Delete %s products',
    hiddenNumProduct: 'Stop selling %s products',
    activeNumProduct: 'Sell %s products',
    deleteNumProductConfirm: 'Are you sure you want to delete %s this product?',
    hiddenNumProductConfirm: 'Are you sure you want to stop selling %s of this product?',
    activeNumProductConfirm: 'Are you sure you want to sell %s this product?',
    canNotDeleteProduct: 'You cannot delete %s products because it is already in the order',
    barcodeExist: 'This barcode already exists for another product.',
    combo: 'Combo',
    comboProduct: 'Combo product',
    comboRecipe: 'Combo recipe',
    comboRecipeHint: 'Combo stock is deducted from the child products below.',
    comboSelectChild: 'Select child product',
    comboAddChild: 'Add child product',
    comboEmpty: 'No child products in this combo recipe',
    comboQuantity: 'Quantity in combo',
    comboAutoBuyPrice: 'Purchase price is calculated automatically from the combo recipe',
    comboDerivedStock: 'Stock is derived from child products',
    comboTypeLabel: 'Product type',
    comboTypeNormal: 'Normal product',
    comboTypeCombo: 'Combo product',
    comboSelectChildWarning: 'Please select a child product for this combo.',
    comboQuantityWarning: 'Child product quantity must be greater than 0.',
    comboDuplicateChildWarning: 'A child product can only appear once in the combo recipe.',
    comboChildCannotBeCombo: 'A combo child cannot be another combo product.',
    comboSelfWarning: 'A combo cannot include itself.',
    comboVariantNotSupported: 'Combo does not support variants yet. Please remove variants before switching to combo.',
    simpleModeCombWarning: 'Please create the product in full from the product list',
    comboConvertToNormalBuyPriceWarning: 'Please enter a purchase price when converting combo back to a normal product.',
    syncAmount: 'Synchronize inventory with import order',
    syncAmountConfirm: 'The stock of this product is %s. Do you want to update again?',
    type: 'Variant',
    type1: 'Variant(Size, color...)',
    typeHint: 'Class name',
    sku: 'Sku',
    skuExist: 'This sku already exists. Please enter another value!',
    image: 'Image of products',
    nameSoShort: 'Product name must be greater than 4 characters',
    nameExist: 'Product name already exists',
    canNotCreateUnitConvertWithType: 'Cannot create conversion unit for product with variation.',
    limitUploadImage: 'The free version only supports 1 image per product. Please upgrade to add more images!',
    limitContentLength: 'Product description must be less than %s characters!',
    limitImageOffline: 'The offline version only supports 1 image!',
    importNewFromExcel: 'Import new products',
    importUpdateFromExcel: 'Update existing products',
    description: 'Manage and track all your products.'
  },
  category: {
    id: 'Id',
    prefix: 'Categories id prefix',
    title: 'Product categories',
    create: 'Create category',
    name: 'Category name',
    choice: 'Choice category',
    search: 'Filter by id, category name',
    categoryExist: 'Category is exist',
    choiceProduct: 'Select a product to add to your catalog',
    description: 'Manage and track all your categories',
    tips: 'Tips',
    tip1: 'Use a short, easy-to-understand category name (e.g., Drinks, Fast Food...).',
    tip2: 'Categories help in classifying and searching products more quickly.',
    tip3: 'You can assign products to this category right after creation.',
    itemsCountDesc: '%s items currently grouped in this category'
  },
  bestSelling: {
    title: 'Consumer Trends',
    subtitle: 'Best selling products in 30 days'
  },
  importOrder: {
    id: 'Id',
    prefix: 'Products receipt id prefix',
    title: 'Products receipt',
    detail: 'Detail products receipt',
    create: 'Create products receipt',
    edit: 'Update products receipt',
    editProductPrice: 'Change import price',
    editProductPriceWarning: 'Do you want to change the import price of this product to %s?'
  },
  importReturnOrder: {
    id: 'Order code',
    prefix: 'Order code prefix for return to supplier',
    title: 'Import return order',
    detail: 'Import return order details',
    create: 'Add import return order',
    edit: 'Edit import return order'
  },
  provider: {
    id: 'Supplier ID',
    prefix: 'Supplier prefix',
    title: 'Suppliers',
    create: 'Add Supplier',
    name: 'Supplier name',
    choice: 'Supplier selection',
    search: 'Filter by code, name, supplier number',
    categoryExist: 'Supplier name already exists',
    order: 'Orders',
    free: 'Unknown',
    deleteWarning: 'Are you sure you want to delete this supplier? All orders related to this supplier will be changed to unknown supplier.'
  },
  googleDriver: {
    backup: 'Backup',
    backupToDriver: 'Backup',
    loginGoogle: 'You need to be logged into your Google account to perform this feature',
    backupSuccess: 'Backup successful',
    backupError: 'Backup failed',
    emptyBackup: 'No backups found',
    loadingBackupFile: 'Loading backup data',
    backingUp: 'Backing up',
    restore: 'Restore',
    restoreFromDriver: 'Restore',
    restoreSuccess: 'Restore data successfully',
    restoring: 'Restoring data',
    resetData: 'Data reset',
    resetDataDetail: 'Initialize data from scratch',
    resetDataConfirm: 'Are you sure you want to wipe existing data?',
    backupErrorCaseInvalidToken: 'Unable to back up data because your Google account session has expired. Please login and try again!.',
    confirmReplaceOlderTitle: 'Confirm overwrite',
    confirmReplaceOlderDetail: 'We found a newer data version on Google Driver. Are you sure you want to back up your current data?',
    restoreChoose: 'Select the data you want to restore',
    backupRename: 'Edit easy-to-remember name',
    backupAt: 'Backup at'
  },
  staffUpgrade: {
    upgradeForStaff: 'You are renewing the employee. If you have paid before but have not been updated. Please select restore payment.',
    staff1m: 'Extend 1 month',
    staff6m: 'Extend 6 months',
    staff1y: 'Extend for 1 year'
  },
  proVersion: {
    pro: 'Premium Package (VIP)',
    proDetail:
      'Premium Package is a package that uses all the features of the application (excluding staff accounts, and extended branches). Please click "Compare Free - Premium" for more details.',
    staffAcc: 'Staff Account Package',
    staffAccDetail:
      'Package for business stores that want to use staff accounts. The first 1 months are free for the first staff account. One staff account can log in to unlimited devices.',
    warehouseExt: 'Extended Branch Package',
    warehouseExtDetail: 'Extended Branch Package applies to the 2nd branch and beyond. The 2nd branch will be free for one month.',
    linked: 'Linked',
    paymentRecoveryHint: 'Please select your payment to recover for this account!',
    name: 'Premium version',
    detail: 'Buy premium version to use remove ads and not restrict all features of the app',
    removeAds: 'Upgrade premium version',
    removeAdsDetail: 'Only need to buy once, if you bought it will be restored',
    paymentRecovery: 'Restore your payment',
    paymentRecoveryDetail: 'Recovery your payment to premium version',
    purchaseFailed: 'Payment unsuccessful! Please try again.',
    purchaseSuccess: 'Payment successful! Thank you!',
    recoveryPaymentSuccess: 'Successful payment recovery!',
    recoveryPaymentUnsuccess: 'Your payment could not be found!',
    recoveryIfNeed: 'If you have paid before, please choose to restore your payment.',
    cancelIfNeed: 'Cancel anytime on',
    expireDate: 'Expiry date until',
    expired: 'expired',
    yourPackage: 'You are using the premium version',
    packageFull: 'Unlimited Lifetime Package',
    trial: '7 day trial',
    trialDetail: 'Use the premium version for 7 days.\nAfter the time expires, you will return to the free version',
    package1M: '1 month package',
    package3M: '3 months package',
    package6M: '6 months package',
    package1Y: '1 year package',
    package5Y: '5 year package',
    package10Y: '10 year package',
    package1MDetail: 'Use the premium version for 1 month.\nIt will automatically renew when the time expires',
    package3MDetail: 'Use the premium version for 3 months.\nIt will automatically renew when the time expires',
    package6MDetail: 'Use the premium version for 6 months.\nPackages are cumulative over time, and do not automatically renew.',
    package1YDetail: 'Use the premium version for 1 year.\nPackages are cumulative over time, and do not automatically renew.',
    package5YDetail: 'Use the premium version for 5 years.\nPackages are cumulative over time, and do not automatically renew.',
    package10YDetail: 'Use the premium version for 10 years.\nNo auto-renew',
    packageWarehouse1Y: '1 year extended warehouse',
    packageWarehouse1YDetail: 'Add another extension store for 1 year.\nDo not renew automatically',
    packageStaff1Y: 'Employee 1 year',
    packageStaff1YDetail: 'Renew your employee account for 1 year.\nDo not renew yourself',
    serviceFee: 'Service fee',
    serviceFeeDetail: 'Use premium service package to use full functionality of the application. Click details to view information.',
    packageAutoRenew: 'Package auto-renew',
    packageNonAutoRenew: 'Package does not auto-renew',
    notFoundPurchase: 'Your payment was not found',
    purchaseLinkedWithOtherAcc: 'This payment is already linked to another account',
    recoverySumary: 'If you have paid before. The ads are still there or have not used the features of the paid version. Please choose to restore payment below',
    recoverySumary1: 'If you have successfully restored payment but still have limitations or ads, please exit the app and re-enter.',
    purchaseProcessing: 'Payment is still processing, please wait a moment. If the payment is successful but still not updated, please click restore payment.',
    iapInLoading: 'Not ready yet. Please wait a moment',
    yourPackageInfo: 'Your Package',
    compare: 'Compare FREE - PREMIUM',
    trialConfirm: 'Are you sure you want to activate the 7-day PREMIUM trial? When your package expires, it will return to the FREE package',
    trialActive: 'Trial activation',
    trialActiveDetail: 'You are using the free version. Do you want to activate the premium version for 7 days? When the time runs out, it will return to the free version!',
    cancelSubsiOS: `Cancel automatic renewal on iPhone, you do the following steps.
    - Open the Settings app on iPhone.
    - Tap your name.
    - Tap Subscriptions.
    - iPhone displays the Subscriptions menu option in Settings.
    - Tap the subscription you want to manage
    - Tap Cancel Subscription `,
    cancelSubsAndroid: `Cancel a package on Android phone, you do the following steps
    - Go to CH Play App on Android phone> Then tap on the Google Account Name icon
    - Select Payment and Subscription Package
    - Select Subscription Package
    - Select the Package you want to Cancel
    - Select Cancel
    - Select Later
    - Select the Reason you want to cancel the package
    - Select Cancel Subscription Package`,
    canSubs: 'Cancel Renewal',
    autoRenewWarning: 'Cancel renewal',
    autoRenewWarningDetail: 'You are using a monthly auto-renewal plan. Please cancel this plan before purchasing a higher plan to avoid monthly charges!'
  },
  upgrade: {
    hasNewVersion: 'Has new version',
    changelog: 'Changelog',
    upgradeNow: 'Upgrade',
    later: 'Later',
    changeLogs: [
      'Fix blurry text error when choosing a dark theme',
      'Fixed products receipt could not be saved on some devices',
      'Optimize ads to match bright and dark themes',
      'Add feature to send error report file to developer',
      'And fix some other small bugs'
    ]
  },
  profile: {
    title: 'Personal',
    nameShop: 'Name shop',
    email: 'Email',
    address: 'Address',
    numberPhone: 'Phone',
    phone: 'Number phone',
    edit: 'Edit',
    save: 'Save',
    bank: 'IBAN',
    placholderBillInfo: 'This info will be displayed on invoice (Phone, Address, Bank...)',
    placholderBank: 'Enter bank account',
    placholderName: 'Enter shop name',
    profileDetail: 'Update the store identification and contact information.',
    changeAvatar: 'Change avatar',
    emailVerified: 'Email is verified, cannot be changed.',
    placholderEmail: 'Email can not be changed',
    placholderAdress: 'Enter an address',
    placholderPhone: 'Enter your phone number',
    avatarEmpty: 'Please choose a photo',
    nameEmpty: 'Name shop cannot be left blank',
    emailEmpty: 'Email cannot be left blank',
    adressEmpty: 'Address cannot be left blank',
    phoneEmpty: 'Phone number cannot be left blank',
    billInfo: 'Store information',
    freeAcc: 'Free',
    proAcc: 'Premium'
  },
  invoice: {
    stt: 'No',
    titleImport: 'INVOICE',
    titleReturn: 'RETURN INVOICE',
    title: 'INVOICE',
    code: 'Invoice No:',
    totalPrice: 'Amount',
    nameClient: 'Customer',
    order: 'Product code',
    nameProduct: 'Product name',
    number: 'Qty',
    price: 'Total amount',
    money: 'Unit price',
    unit: 'Unit',
    buyer: 'Buyer',
    salesman: 'Salesperson',
    writeFull: '(Sign, write full name)',
    day: 'Day',
    month: 'month',
    year: 'year',
    save: 'Save',
    thanks: 'Thanks for purchasing!',
    draft: 'PRE-INVOICE'
  },
  barcode: {
    title: 'Scan code',
    message: 'Move camera to container to scan'
  },
  help: {
    removeAds: 'Can I remove ads?',
    removeAdsDetail: 'You can remove ads by purchasing the premium version package. You can fully use most of the features of the app without purchasing a package.',
    adsNotDisable: 'I bought the premium version but the ads still appear',
    adsNotDisableDetail:
      '- You go to "Menu icon in the upper left corner" -> "Premium version" -> Select "Restore payment". When a blue message appears, your payment has been restored successfully. Ads will no longer appear. \n- If a red message appears, the payment recovery has not been successful. You Please double check your payment. Or the iTunes Store account has the same payment account. \n- In case you have successfully paid but cannot activate payment recovery. Please contact the developer via email: xgitdev@gmail.com for support',
    recoveryData: 'Can I backup or transfer my data to another machine?',
    recoveryDataeDetail:
      'You can register an account, then open the menu to choose to sync current data, then you will not lose data anymore. In case your device does not have any data, you can skip the sync step.\nTo another device, you just need to log in to your current account to be able to use it normally.',
    recoveryDataAuto: 'Is it possible to backup data automatically?',
    recoveryDataeAutoDetail: 'You can use this features in settings. However, this features will only be available in the premium version'
  },
  importFromCSV: {
    textHint: 'Import text data from your CSV file here',
    title: 'Import from csv file',
    choiceFile: 'Choose file',
    intro: 'Please enter the content below to create a bulk order. You can see samples and instructions at',
    enterText: 'Enter text',
    newCustomer: 'New customer',
    productInvalid: 'Invalid product',
    productInvalidMessage: 'Invalid product key. Please check the code of the product highlighted in red ',
    check: 'Test',
    save: 'Save order',
    emptyDataMessage: 'No orders found yet',
    complete: 'Imported complete',
    gotIt: 'I got it',
    here: 'here',
    syntaxIntro1: 'You can see the sample CSV file here.',
    syntaxIntro2: 'Then you need to open your CSV file as text, then copy the contents of the CSV file and paste it into the data entry box in the input box.',
    syntax: 'Syntax',
    examp: 'Example',
    syntaxTut: 'Please format the data according to the syntax below. Orders are separated by a carriage return. ',
    syntaxDetail:
      'Phone number | Customer name | Address, Surcharge, Product code | Quantity | Discount \nPhone number | Customer name | Address, Surcharge, Product code | Quantity | Discount, Code Products | Quantity | Discount \nPhone number | Customer name | Address, Surcharge, Product code | Quantity | Discount, Product code | Quantity | Discount, Product code | Quantity | Discounts, Product Code | Quantity | Discounts',
    syntaxExamp:
      '0123456789 | NGUYEN VAN A | Ha Noi, 10, SP1 | 5 | 0 \n0123456789 | NGUYEN VAN A | Ha Noi, 10, SP1 | 5 | 0, SP2 | 4 | 0 \n0123456789 | NGUYEN VAN A | Ha Noi, 10, SP1 | 5 | 0, SP2 | 4 | 0, SP3 | 4 | 0 '
  },
  bill: {
    name: 'Invoice',
    title: 'Invoice payment',
    product: 'Products',
    day: 'Sale date',
    amount: 'Qty',
    money: 'Amount',
    totalMoney: 'Total Amount',
    thanks: 'Thanks for your purchasing!',
    createBy: 'Professional sales with the app',
    unit: 'Unit',
    discount2: 'Discount %',
    discount1: 'Discount money',
    customImage: 'Custom Image',
    customText: 'Custom text',
    moneyText: 'Amount in words'
  },
  printer: {
    name: 'Printer',
    connected: 'Printer connected!',
    title: 'Printer connection',
    find: 'Searching for a printer. Please wait...!',
    empty: 'No printers found',
    unknow: 'Unknown',
    pressToConnect: 'Touch to connect and test print',
    notConnect: 'Please connect the printer in settings.',
    trial: '%s of trial remaining',
    trialExpired: 'You have run out of test prints. Please purchase premium version to use this feature',
    printError: 'Printer not ready, please try again',
    devicesTested: 'Device tested by the development team: xPrinter 58iiH, GOOJPRT PT-210',
    choice: 'Choice printer',
    require: 'Support thermal bill printer with USB connection. The computer must install the printer driver first to be able to connect',
    fixOnWindow: 'Fix can not connection on Windows',
    printerDriverType: 'Type of connection driver',
    printerDriverTypeDetail: 'Select the type of printer driver you have installed on your computer.',
    printerDriverTypeList: ['Printer driver (brand driver)', "Zadig driver (aSeller's instructions)"],
    printerSizeDetail: 'Select your printing paper size. Supported paper sizes A4, A5, 80mm, 58mm',
    choiceDriverTypeWarning: 'Please select the type of installed driver.'
  },
  importFromExcel: {
    textHint: 'Enter text data from your Excel file here',
    title: 'Import from Excel',
    choiceFile: 'Select file',
    intro: 'Please enter the content below to create a bulk order. You can see samples and tutorials at',
    introProduct:
      'Please select excel file to quickly import products. Please do not select the file you exported from the list of products because the file format is not the same. You can see samples and tutorials at',
    introProduct1: 'You should use the web version for easier operation. You must enter units and categories in advance for the system to recognize',
    enterText: 'Enter text',
    newCustomer: 'New Customer',
    productInvalid: 'Invalid products',
    productInvalidMessage: 'Invalid commodity code. Please double check the code of the item highlighted in red',
    check: 'Check',
    save: 'Save %s products',
    emptyDataMessage: 'No products found',
    complete: 'Import done',
    gotIt: 'I got it',
    here: 'here',
    syntaxIntro1:
      'You should import less than 500 records at a time. You can split them into multiple files to import. Products cannot have the same name, code, or SKU. You should delete any columns that do not need to be changed. You can refer to the sample file here.',
    syntaxIntro2: 'Then you need to open your Excel file as text, then copy the contents of the Excel file and paste it into the input box in the input box.',
    found: 'Found %s products',
    demo: 'Example file'
  },
  unit: {
    id: 'Id',
    title: 'Unit',
    choice: 'Choice unit',
    create: 'Create new unit',
    name: 'Unit name',
    search: 'Filter by code, unit name',
    exist: 'Unit name already exists',
    tips: 'Tips',
    tip1: 'Use standard units of measure (e.g., Piece, Pack, Box, Case...).',
    tip2: 'Units help in more accurate inventory management and sales.',
    tip3: 'You can set up unit conversions directly in the product details.',
    convert: 'Conversion unit',
    addConvert: 'Add conversion unit',
    editConvert: 'Edit conversion units',
    valueConvert: 'Converted value',
    invalidValueConvert: 'Conversion unit information is not valid. Please check again!',
    invalidMainUnit: 'Please select a main unit before creating a conversion unit!',
    sameMainUnit: 'The conversion unit cannot be the same as the main unit. Please choose another unit!',
    deleteUnitConvert: 'Delete conversion unit',
    deleteUnitConvertWarning: 'Are you sure you want to delete this conversion unit? Conversion units that have been used in an order cannot be deleted.',
    choiceMainUnitFirstWarning: 'Please select the unit of measure for the product before creating the conversion unit.'
  },
  timeFilter: {
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    custom: 'Custom',
    thisMonth: 'This month',
    lastMonth: 'Last month',
    choiceStartDate: 'Start',
    choiceEndDate: 'End',
    choiceMonth: 'Choose month'
  },
  autoRestoreDb: {
    title: 'Data Recovery',
    message: 'We detected a newer data version of your account. Do you want to sync with that latest data?'
  },
  support: {
    title: 'Live Support',
    emailSupportDetail: 'You want to contact us. Please choose one of the following contact methods.',
    emailSupport: 'Email developer',
    zaloSupportDetail: 'If you need urgent support such as an application error, or FAQ on how to use it. Please choose support via Zalo',
    zaloSupport: 'Support via zalo group'
  },
  customerDebt: {
    title: 'Total liabilities',
    total: 'Total outstanding',
    customerDebtStatistial: 'Debt by customer',
    beginningBalance: 'Beginning Balance',
    beginningDebts: 'Beginning Debits',
    closingBalance: 'Closing Balance',
    closingDebts: 'Closing Debts',
    showAll: 'Show all cash flows',
    simple: 'Simple version',
    hideProduct: 'Hide product',
    timeRange: 'TIME RANGE',
    displayConfig: 'DISPLAY CONFIG',
    debtCheckWarning: '(Please re-check and reconcile the information above)',
    scanToPay: 'SCAN TO PAY',
    scanToPayHint: 'Use Banking app or E-wallet to scan code'
  },
  returnOrder: {
    edit: 'Edit return order',
    create: 'Add return order'
  },
  maintenance: {
    title: 'Maintenance',
    message: 'Our server is undergoing maintenance for about %s minutes. Please try again later!!!',
    timeout: "Sorry! An error has occurred. Please try again after a few minutes. If it still doesn't work, please contact our support team!!!",
    messageTimeout: "Our server is a bit busy! Please try to download again! If it still doesn't load, take a break for about 5 minutes and try again!. Thank you very much!",
    networkError: 'Network error',
    networkErrorDetail: "Internet line error. Please try to check your WIFI or 4G again. If you still can't download, please contact us for help! Thank you very much!"
  },
  financialBook: {
    debt: 'Debt note',
    createDebt: 'Create debt',
    title: 'Cash Flow',
    receipts: 'Receipt',
    paymentVoucher: 'Payment',
    moneyFromCustomer: 'Customer Collection',
    moneyForProvider: 'Payments to suppliers',
    moneyForReturn: 'Refund for refund',
    moneyFromReturn: 'Money received from refund',
    idAutoGen: 'Automatic code',
    cash: 'Cash',
    bank: 'Bank',
    totalFund: 'Total Fund',
    submitter: 'Creator',
    typeCharge1: 'Receipts type',
    typeCharge2: 'Payment type',
    receipt: 'Cash Receipt',
    vouchers: 'Cash Payment',
    fullName: 'Full Name',
    submitters: 'Submitter',
    money: 'Amount',
    textEmptyFinancial: "You don't have any receipts/payments yet.",
    accountBank: 'Receiving account',
    nameBank: 'Bank account',
    accountNumber: 'Account Number',
    accountHolder: 'Account Holder',
    receiptForOrder: 'Receipt for order',
    paymentForOrder: 'Order slip',
    receiptFromCustomer: 'Receipt from customer',
    receiptAutoGenFor: 'Receipt automatically generated for order',
    paymentForProvider: 'Payment for suppliers',
    paymentForCustomer: 'Payment slip for customer',
    paymentVoucherAutoGenFor: 'Order auto-generated check',
    autoFinancialCanNotEdit: 'This ticket is automatically generated. Please correct the related order',
    createType: 'Create new type',
    deleteType: 'Delete type',
    deleteTypeWarning: 'Are you sure you want to delete %s?',
    exportBill: 'Export',
    deleteBill: 'Delete',
    deleteBillWarning: 'Are you sure you want to delete this cash transactions?',
    investment: 'Investment',
    investmentDetail:
      'Input fund is the total balance (Revenue - expenditure) calculated from the time of initial sale to the beginning of the period. \nFor example: The time you choose is this month, then the investment fund is the balance from before the first day of the month.',
    totalRevenue: 'Total revenue',
    totalSpending: 'Total spending',
    totalBlance: 'Total blance'
  },
  sortType: {
    newest: 'Latest',
    oldest: 'Oldest',
    alphabet: 'Alphabet'
  },
  guide: {
    revenue: 'Total revenue',
    expenditure: 'Total expenditure',
    title: 'Tips for beginners',
    expenseReport: 'Financial book',
    product: 'To get started, Add the product or service you offer.',
    customer: 'Adding a new customer is a basic operation for you to initialize customer information and manage debt in the future transaction process.',
    provider: 'You need to create a supplier to be able to manage all data related to the Supplier: Contact information, debt, import history...',
    order: 'Orders will be recorded out of stock, delivered to customers as soon as they are created... You add Order Notes and Tags to the order to facilitate order filtering..',
    category: 'Category is a place for you to manage a collection of item categories.',
    complete: "You've mastered the basics. There are many more features that aSeler has designed for you, keep exploring!!"
  },
  productHistoryLog: {
    title: 'Repository History',
    sale: 'Exporting',
    import: 'Import Repository',
    update: 'Checkout',
    return: 'Refund stock',
    delete: 'Cancellation refund',
    amount: 'Amount of transactions',
    result: 'Amount after transaction',
    importReturn: 'Return'
  },
  orderType: {
    sale: 'Sales',
    return: 'Return',
    import: 'Import',
    receipt: 'Receipt',
    payment: 'Payment',
    importReturn: 'Return imported products',
    debt: 'Debt'
  },
  newCodepush: {
    title: 'A newer version is available',
    des: 'There is a newer version just released. Do you want to update now',
    cancel: 'Later',
    ok: 'Update'
  },
  printSetting: {
    ...VI.printSetting,
    tearOffset: 'The distance from the cutter to the print head (mm)',
    tearOffsetDetail: 'This area will be used to release enough paper for cutting without losing the printed content',
    title: 'Printer settings',
    type: 'Printer Type',
    typeDetail: 'If your printer only prints receipts, select ESC/POS printer. If your printer can print both labels and receipts, select ZPL or TSPL.',
    size: 'Print size',
    connection: 'Printer',
    asellerLogo: 'Show aSeller logo',
    bluetooth: 'Bluetooth printer',
    wifi: 'WIFI Printer',
    deviceIp: 'Printer IP address',
    deviceIpEx: 'eg: 192.168.1.100',
    invalidIP: 'Please enter a valid IP!',
    canNotConnectIP: "Cannot connect to this IP. Please double check the printer's IP!",
    notReady: 'The printer is not ready. Please go to printer settings first!',
    support:
      'Supports ESC/POS thermal printers connected to WIFI, Bluetooth, USB.\nNote: label printers are not supported. \nOnly supports 1 device connected to the printer at a time.\nTested printers: xPrinter 58iiH (Bluetooth), GOOJPRT PT-210 (Bluetooth), xPrinter T80L (WIFI)',
    qrBank: 'Add custom photo at the end of invoice',
    qrBankDetail: 'You can add a bank QR code, displayed at the bottom of the invoice',
    orientation: 'Print size',
    potrait: 'Portrait',
    landscape: 'Horizontal',
    method: 'Supported languages',
    esc: 'ESC/POS, ESC...',
    escDetail: 'Is a printer dedicated to printing invoices',
    tsc: 'ZPL, EPL, TSPL...',
    tscDetail: 'The printer can print invoices, stickers, barcodes...',
    threshold: 'Text Boldness',
    thresholdTypeList: ['Medium', 'Bold', 'Extra Bold'],
    speed: 'Print speed',
    speedTypeList: ['Auto', 'Slow'],
    spacingBottom: 'The space below'
  },
  homeOfflineWarning: {
    message: 'You are using offline. Please switch to online to use more features. And will not lose data.',
    helpButton: 'How to switch to online'
  },
  statStock: {
    typeChoice: 'Inventory statistics by',
    inventoryCapital: 'Inventory'
  },
  customerGroup: {
    title: 'Customer group',
    search: 'Filter by name, or code',
    id: 'Group Code',
    prefix: 'Group code prefix',
    create: 'Add group',
    choice: 'Select customer group',
    choiceCustomers: 'Add customer to group',
    name: 'Group name',
    tablePrice: 'Price list',
    priceHint: 'The price list will automatically be applied to the sales order when the customer is in this group',
    editNotice: 'Editing mode - Tap "Save" at the top to complete',
    removeCustomer: 'Are you sure you want to remove this customer from the group?'
  },
  settings: {
    title: 'Settings',
    garena: 'General settings',
    home: 'Home Settings',
    order: 'Order Settings',
    product: 'Product settings',
    invoice: 'Invoice settings',
    debt: 'Balance settings',
    point: 'Points settings',
    salesGroup: 'Sales & Invoices',
    systemGroup: 'System & Interface',
    businessGroup: 'Customers & Business',
    accountGroup: 'Account & Security',
    displayAndTheme: 'Display & Theme',
    currencyAndTime: 'Currency & Time',
    security: 'Security',
    stockSettings: 'Inventory Settings',
    homeWidgets: 'Home Widgets',
    pointSettings: 'Points Configuration',
    resetPointTitle: 'Reset Settings',
    systemPermissions: 'System Permissions',
    invoiceSettings: 'Invoice Settings',
    debtSettings: 'Debt & Balance',
    orderSettings: 'Order Settings',
    descOrder: 'Status, rounding, extra fee, hourly service',
    descProduct: 'Inventory, cost price, initial stock',
    descInvoice: 'Invoice template, VietQR, bank account',
    descPrinter: 'Paper size, Bluetooth, Wifi, USB printer',
    descShift: 'Shift opening, closing, cash handover',
    descGeneral: 'Theme, language, font size, currency, PIN',
    descHome: 'Display revenue, charts, financial report',
    descPermission: 'Camera, photo library, Bluetooth, notification',
    descPoint: 'Member reward points, conversion rates',
    descShop: 'Branches, staff management, sales website',
    descEInvoice: 'Electronic invoice configuration and issuance',
    descPassword: 'Update account password',
    descDeleteAcc: 'Permanently delete account and shop data',
    shopManager: 'Shop Manager',
    staffRole: 'Staff',
    granted: 'Granted',
    grantPermission: 'Grant',
    noVietQRConfig: 'VietQR bank account not configured',
    uploadQRImage: 'Upload QR code image',
    s2aHkdGroup: 'S2A-HKD Business Group',
    s2aHkdGroupDetail: 'Default business group when exporting S2A-HKD ledger',
    s2aHkdTaxRate: 'S2A-HKD Default VAT Rate (%)',
    s2aHkdTaxRateDetail: 'Used when product/order has no clear VAT',
    s2aHkdTncnRate: 'S2A-HKD Personal Income Tax Rate (%)',
    s2aHkdTncnRateDetail: 'Personal income tax rate (%) used when exporting S2A-HKD',
    manualEnterIPDetail: 'Enter printer IP directly if not detected',
    previewPrint: 'Print preview'
  },
  customerPoint: {
    pointShort: 'Points',
    description: 'Customer Rewards Management',
    point: 'Accumulated points',
    history: 'Cumulative history',
    use: 'Enable point accumulation function',
    mtpRate: 'Point conversion rate',
    mtpRateDetail: 'Order value %s%s = 1 cumulative point',
    ptmRate: 'Conversion rate to money',
    ptmRateDetail: '1 point = %s%s',
    allowPayment: 'Allow payment in points',
    allowForSaleProduct: 'Accumulate points for discounted products',
    allowForOrderPayByPoint: 'Accumulate payment orders with bonus points',
    change: 'Update accumulated points',
    invalidPoint: 'Invalid score',
    invalidNote: 'Please enter a note',
    usePoint: 'Using Point',
    showPointOnInvoice: 'Show points on invoice',
    reset: 'Delete all accumulated points',
    resetWarning: "Are you sure you want to delete all of the customer's current accumulated points?"
  },
  shift: {
    title: 'End of shift',
    end: 'End of shift',
    totalOrder: 'Total invoice',
    totalMoney: 'Total shift fee',
    paid: 'Total handover fee',
    staff: 'Employee',
    cash: 'Cash',
    bank: 'Transfer',
    emptyOrder: 'No orders have been created during this shift.',
    shiftOrder: 'Orders from shift',
    open: 'Open shift',
    closed: 'Closed',
    opening: 'Opening',
    openingAmount: 'Opening cash',
    handoverType: 'Handover type',
    openingAmountDetail: 'Cash available at the start of a shift',
    actualHandoverAmount: 'Actual handover amount',
    differenceAmount: 'Difference',
    totalExpectedHandoverAmount: 'Total handover amount needed',
    orderUnit: 'orders',
    currencyUnit: '₫',
    endReport: 'END-OF-SHIFT REPORT',
    ended: 'Shift ended',
    shift: 'Sales shift',
    shiftClosedDesc: 'Shift closed and handed over',
    actualHandoverDesc: 'Actual amount handed over by staff',
    updatingOnClose: 'Will be updated upon closing shift',
    matchedDiffDesc: 'Amount matches perfectly',
    checkDiffDesc: 'Discrepancy needs to be investigated',
    diffCalculatedOnClose: 'Calculated after shift handover',
    searchOrdersPlaceholder: 'Search by order ID, customer, phone...',
    handoverTypeDetail: 'Payment methods collected when staff close and hand over the shift',
    requireOpening: 'Require opening shift',
    requireOpeningDetail: 'Sales orders can only be created when a shift is open',
    settings: 'Shift settings',
    settingsDetail: 'Configure shift opening and handover',
    openError: 'Cannot open shift',
    expectedHandoverAmount: 'Expected handover amount',
    totalMoneyInShift: 'Total money in shift',
    needHandover: 'Expected',
    endConfirm: 'Are you sure you want to close this shift?'
  },
  warehouse: {
    title: 'Warehouse (branch)',
    renew: 'Renew warehouse',
    choice: 'Choose warehouse',
    intro: 'Different warehouses will have different inventory, sales, financial... indexes. Go to "Inventory Management" to create a new warehouse.',
    stat: 'Stock status',
    createNew: 'Create ticket',
    create: 'Create warehouse',
    checkId: 'Inventory code',
    name: 'Warehouse name',
    check: 'Check inventory',
    createCheck: 'Create inventory check',
    history: 'Inventory history',
    noHistory: 'No inventory history yet. Please create a new ticket',
    noTransferHistory: 'No transfer history yet!',
    totalProduct: 'Total Product',
    tmpCheck: 'Temporary ticket',
    cancelCheckConfirm: 'Are you sure you want to cancel this check?',
    cancelTransferConfirm: 'Are you sure you want to cancel this transfer?',
    default: 'Main warehouse',
    address: 'Warehouse address',
    manager: 'Warehouse management',
    detail: 'Inventory information',
    transfer: 'Transfer warehouse',
    transferCard: 'Detail transfer',
    checkCard: 'Detail check',
    exportTransferCard: 'Warehouse transfer card',
    exportCheckCard: 'Inventory check card',
    emptyTargetWarehouse: 'Invalid target warehouse. Please select destination warehouse!',
    limit: 'Note: Each account gets 1 month free for the 2nd warehouse. After expiration, you need to renew to use',
    expired: 'This warehouse has expired. Please renew to use!',
    package1Y: '1 year extension',
    importFromExcelHint: 'Quickly import products from excel file.',
    importFromExcelEmptyChange: 'No changes found.',
    stopActive: 'Deactivate',
    stopActiveWarning: 'When you deactivate a repository, it will be hidden from the selection list. Are you sure you want to deactivate this repository?',
    emptyTransferHint: 'Tap "Scan Barcode" or "Product" to start warehouse transfer',
    emptyCheckHint: 'Tap "Scan Barcode" or "Product" to start stock check',
    noProduct: 'No product selected'
  },
  homeScreen: {
    ...VI.homeScreen,
    support: 'Do you need support?',
    supportDetail: 'Please select a support contact form below so we can assist you.',
    changelog: 'Changelog',
    changelogDetail: 'Track the changelog for changes, the latest features of the application. ',
    autoUpdateNoAvailable: 'You are using the latest version!',
    autoUpdateFailed: 'There was an error during the update process. Please try again later!',
    autoUpdate: 'Update patch',
    hotlineSupportDetail: 'Hotline only supports business hours, from 09:00 - 17:00.',
    autoUpdateDetail: 'The system will update the latest patch to fix some minor bugs without installing the latest version on the app store.',
    vipExpired: 'Your premium package has expired. Please renew for full functionality!',
    timeZoneNew: 'Update time zone',
    timeZoneConfirm: 'Are you sure you want to update the report to the new time zone? You can reset it in "General settings"',
    timeZoneNewDetail:
      'Your device is using the %s time zone. We have updated the report to correctly reflect your current time zone. Previously exported reports may be subject to change. To review older reports, please visit "Statistics (old)"'
  },
  productSetting: {
    sort: 'Sort list',
    sortDetail: 'Sort products by',
    sortTypes: ['Newest first', 'Alphabetically named', 'Oldest first', 'Expired date']
  },
  intro: {
    shift: 'This function is for service business type. Employees use the employee app to close shifts. Employee shift closing information will be displayed here.',
    customerGroup:
      'This feature is to group customer objects. For example, level 1 agent, level 2 agent... You can create a price list of products for each customer group. When creating an order, if a customer belongs to a group with a price list, that price list will automatically be applied!',
    emptyProduct: 'There are no products yet. Please add more products to continue!',
    draftOrder:
      'This function is suitable when you want to create multiple orders at the same time. And you can create sales orders even without a network connection. This is very useful in case your connection has problems, or the server is under maintenance.'
  },
  printBarcode: {
    print: 'Print barcode',
    list: 'Barcode list',
    config: 'Barcode printing configuration',
    size: 'Size of 1 stamp (Length x Width) (mm)',
    note: 'Note',
    column: 'Number of columns of the print size',
    paddingH: 'Horizontal distance between 2 stamps (mm)',
    paddingV: 'Vertical spacing between 2 stamps (mm)',
    noteDetail: 'In case the barcode cannot be scanned, or is partially lost. Please use a larger paper size, or shorten the barcode',
    dpi: 'Printer Dpi',
    multiUpdateQuantity: 'Update bulk quantity',
    invalidQuantity: 'Invalid quantity!',
    barcodeWidth: 'Width of the barcode',
    autoPrintWhenInBill: 'Automatically print labels',
    autoPrintWhenInBillDetail: 'Automatically print labels after printing bills',
    printerNotRealdy: 'The label printer is not ready. Please go to the code printing settings to update!',
    contentToDisplay: 'Content to display on the label',
    parameters: 'Parameters',
    lengthXWidth: 'Length × Width (mm)',
    sampleProduct: 'Sample product'
  },
  draftOrder: {
    title: 'Draft invoice',
    manager: 'Manage draft invoice',
    cancel: 'Cancel draft',
    cancelConfirm: 'Are you sure you want to cancel this draft invoice?',
    noConnectionWarning: 'Your device is not connected to the network. Go to "Manage draft invoices" below to create draft invoices without needing an internet connection.',
    emergencyModeWarning: 'You are in emergency mode. Orders are only saved temporarily on your device and have not been recorded to the server.',
    exportInvoice: 'Pre-Invoice'
  },
  deleteAcc: {
    title: 'Delete account',
    warning: 'Are you sure you want to delete this account? Once deleted, you will not be able to restore the data. You will need a confirmation code sent to your email!',
    confirmCode: 'Confirmation code',
    confirmCodeShort: 'Confirmation code is too short'
  },
  debtNotify: {
    name: 'Debt Collection Notice',
    title: 'Debt to collect from ',
    money: 'Amount: '
  },
  restartApp: {
    title: 'Restart app',
    detail: 'Do you want to start the application so that the changes are updated?'
  },
  appError: {
    eyebrow: 'Something went wrong',
    title: 'App needs to restart',
    detail: 'An unexpected error occurred. Please restart app to continue.',
    reload: 'Restart app'
  },
  shopSetting: {
    link: 'Website link',
    publicSetting: 'Set up a sales website',
    publicSettingHint: 'Customers can order directly through the link the shop sends to customers. You need to activate the VIP+ package to use this function.',
    userName: 'Store identifier',
    userNameHint: 'This name will be displayed on the link sent to customers. It must not contain spaces or special characters (hyphens and underscores are allowed).',
    staffRefLink: 'Reference link for staff',
    staffRefLinkHint: "Staff's shop link. When customers click on this link, the order will be counted for that staff",
    customerCanRegister: 'Allow customers to register for an account',
    customerCanRegisterDetail: 'Customers can register for an account themselves. If enabled, the product price will be publicly displayed to all customers.',
    retailPurchase: 'Allow retail customers to purchase',
    retailPurchaseDetail: 'Customers can create orders without an account',
    theme: 'Interface',
    themeDetail: 'Choose the website interface to display to customers',
    shopName: 'Store name',
    banner: 'Store banner image',
    bannerDetail: 'Store banner image recommended size 1024x512px',
    color: 'Color',
    colorDetail: 'Edit the color of the sales website interface',
    colorTextNormal: 'Normal font color',
    colorTextActive: 'Embossed font color',
    colorBackground: 'Background color',
    showPricePublic: 'Show price',
    showPricePublicDetail: 'Show public price to all visitors',
    initWebsite: 'Initialize website',
    moreSettingOnWeb: 'Please use the web version to configure the sales website more fully.',
    productList: 'Product List',
    productListDetail: 'Set the product list displayed on the sales website. By default, all products will be displayed',
    promotionList: 'Promotion List',
    promotionListDetail: 'Set up a list of promotions to display on the sales website. Default does not display',
    domain: 'Custom domain name',
    domainDetail: 'Configure a custom domain name for your store',
    domainDetailWidthIP: 'To configure a custom domain name for your store.\nPlease disable Cloudflare and point your domain IP to %s',
    requirePlus: 'Please activate the PLUS package before performing this function!'
  },
  promotion: {
    edit: 'Edit promotion',
    create: 'Create promotion',
    choice: 'Choose promotion',
    title: 'Promotion',
    manage: 'Manage promotion',
    detail: 'Promotion details',
    name: 'Promotion name',
    code: 'Promotion code',
    type: 'Promotion type',
    info: 'Promotion information',
    order: 'Order discount',
    product: 'Product discount',
    orderGift: 'Order gift',
    productGift: 'Product gift',
    minMoney: 'Minimum amount',
    minQuantity: 'Minimum quantity',
    value: 'Promotion value',
    price: 'Promotion price',
    discountPercent: 'Discount percentage',
    time: 'Promotion time',
    choiceGift: 'Choose gift',
    gift: 'Gift',
    originalPrice: 'Original price',
    delete: 'Delete promotion',
    deleteConfirm: 'Are you sure you want to delete this promotion?',
    uniqueQuantity: 'The minimum number of %s must be different!'
  },
  invalidField: {
    name: 'Please enter a valid name field!',
    timeFrom: 'Please enter a valid start time!',
    timeTo: 'Please enter a valid end time!'
  },
  serviceSale: {
    branch: 'Branch',
    found: 'No matching items were found',
    clickDownload: 'Click to download',
    use: 'Use',
    empty: 'Empty',
    table: 'Table',
    emptyTable: 'No table is used yet',
    createBranchWarning: 'You can add new branches on aSeller management app',
    addProduct: 'Add item',
    addProduct1: 'Add item',
    scanBarcode: 'Scan Barcode',
    changeTable: 'Change table',
    orderNotCreate: 'Order not created or no product yet',
    changeTableInput: 'Enter table number to change',
    error: 'Error',
    finish: 'Done',
    selected: 'Selected',
    choiceProduct: 'Select item',
    choiceProduct1: 'Select item',
    addNewProduct1: 'Add new item',
    addNewProduct: 'Add new',
    selectTable: 'Select a table to continue',
    tableManagement: 'Table management'
  },
  payment: {
    payment: 'Payment',
    cash: 'Cash',
    transfer: 'Transfer',
    totalMoney: 'Total Money',
    addOrder: 'Add to cart',
    order: 'Create Order',
    number: 'Quantity',
    total: 'Total',
    part: 'Part',
    client: 'Client',
    customRetail: 'Retail',
    detailPayment: 'Payment details',
    detailClient: 'Customer details',
    nameUser: 'Customer name',
    newCustomer: 'New Customer',
    phone: 'SDT',
    email: 'Email',
    address: 'Address',
    free: 'Free',
    note: 'Notes',
    updateOrder: 'Update Order',
    discount: 'Discount',
    surcharge: 'Additional charge',
    goodsMoney: 'Money:',
    totalAmount: 'Total Accounts Receivable:',
    notePayment: 'Once confirmed, it cannot be changed'
  },
  button: {
    yes: 'Yes',
    no: 'No',
    ok: 'Ok',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    edit2: 'Rename',
    login: 'Login',
    logout: 'Logout',
    success: 'Complete',
    finish: 'Done',
    confirm: 'Confirm'
  },
  alert: {
    ...VI.alert,
    orderNotCreate: 'Order has not been created or has no product',
    enterFullData: 'Please enter enough data with an asterisk',
    error: 'Error',
    emptyBranch: 'No branches yet. Please contact the store owner to create',
    messager: 'Notice',
    openingDay: 'You cannot edit when the start date is less than the current date',
    delete: 'Are you sure you want to delete this edit',
    emptyInput: 'Username or password cannot be empty',
    success: 'Success',
    textEmpty: (value) => {
      return `${value} information cannot be empty`;
    },
    department: 'You have not selected a facility',
    score: 'Score cannot be greater than the number of questions',
    logout: 'Are you sure you want to exit the App?',
    expiredLessThan7Day: 'Your account has expired, You have 7 days to renew it',
    expiredGreaterThan7Day: 'Your account has expired, Please contact management to renew it',
    userNameHasSpace: 'Username cannot contain spaces',
    userNameIsShort: 'Username must be more than 5 characters',
    passwordIsShort: 'Password must be more than 5 characters',
    emailInvalid: 'Invalid email',
    productCreateOrUpdateFaild:
      'Failed to save the product. Please try removing the image or choosing a different one. If the issue persists, contact our support team for assistance!'
  },
  composition: {
    create: 'Create component',
    title: 'Component',
    name: 'Component Name',
    intro: 'Ingredients are part of a product. Each product can include many different ingredients. You can add ingredient information in the edit or add product section',
    search: 'Search for Components'
  },
  bussinessType: {
    title: 'Business type',
    detail: 'Choose the business type that suits your business',
    type_0: 'Retail',
    type_1: 'Grocery, Supermarket',
    type_2: 'Cafe, milk tea',
    type_3: 'Fashion',
    type_4: 'Cosmetics',
    type_5: 'Mother & Baby',
    type_6: 'Bakery',
    type_7: 'Restaurant',
    type_8: 'Karaoke, Billiards',
    type_9: 'Pharmacy',
    type_10: 'Toys'
  },
  hourlyService: {
    name: 'Name of the hourly service item',
    nameHint: 'The name of the hourly service item will appear as an item on the invoice',
    defaultName: 'Usage time',
    title: 'Hourly billing',
    detail: 'Pay by hour of service usage. \nOnly supported on retail and service interfaces',
    tablePrice: 'Hourly pricing table',
    errorData: 'Invalid data. Please enter at least 1 item!',
    stopTime: 'Stop timing',
    stopTimeWarning: 'Do you want to stop the service timing to make a payment?'
  },
  extraTopping: {
    errorSeparateProductNonTopping: 'Cannot separate products without topping',
    list: 'List of toppings',
    isTopping: 'Is an additional item',
    detail:
      'Is an item attached to another item (eg pearl topping for milk tea...). \nYou will not be able to add this item directly to the order..\nExtra topping items will also not be able to track inventory',
    choice: 'Select topping',
    name: 'Extra topping',
    canNotAddToOrder: 'Toppings cannot be added directly to an order.'
  },
  comboVoucher: {
    voucher: 'Voucher code',
    activeVoucher: 'Activate voucher code',
    activeVoucherDetail: 'Already have a voucher code? Activate your code here.',
    emptyKey: 'Please enter your voucher code!',
    choiceData: 'Please select the service you want to activate below, then click activate to complete.',
    invalidKey: 'Voucher code is invalid!',
    activeVoucherConfirm: 'Are you sure you want to activate this code? This action cannot be reversed. Please double check before clicking agree.',
    activeSuccess: 'Code activated successfully. Please reload the page to take effect.'
  },
  protection: {
    active: 'Activate security',
    detail: 'Automatically lock the app with a PIN after inactivity',
    enterPass: 'Require password entry',
    pin: 'PIN',
    pinRequire: 'PIN must be 4 digits',
    wrongPass: 'Wrong password',
    forgotPin: 'Forgot PIN',
    forgotPinDetail: 'To reset the PIN, you must re-enter the account password. Are you sure you want to do this?'
  },
  extraFee: {
    name: 'Extended Surcharge',
    detail: 'An extended surcharge for sales orders. The amount will be added to the order. If enabled, it will appear in the sales interface.',
    table: 'Extended Surcharge Table',
    fields: ['Name', 'Default Value', 'Unit', 'Status', 'Action']
  },
  introData: [
    {
      title: 'Welcome to aSeller POS!',
      detail: 'A smart sales management solution that helps you stay in control anytime, anywhere.'
    },
    {
      title: 'Easily manage orders, products & customers',
      detail: 'Track revenue, expenses, debts, inventory, and print invoices with just a few taps..'
    },
    {
      title: 'Your data is securely stored in the cloud and easily synced across multiple devices.',
      detail: '📶 Access anytime without worrying about data loss, even when switching devices!'
    },
    {
      title: 'Managing sales has never been easier!',
      detail: 'Set up your store, add products, and start selling with aSeller POS today.'
    }
  ],
  errorSupport: {
    title: 'System error',
    detail: 'System error. Please send this message to aSeller team for fastest support!\nError code: %s',
    support: 'Request support'
  },
  otherApps: [
    {
      title: 'aSeller Sales Staff',
      detail: 'This application is for employees. You can create employee accounts in the "Staff List - Add" section'
    },
    {
      title: 'aSeller POS Offline',
      detail: 'Free sales management application that does not require internet. No monthly maintenance fee. Data is stored on the device. Cannot be used on multiple devices'
    },
    {
      title: 'aSeller FNB',
      detail: 'A specialized management application designed specifically for restaurants, cafes, and bubble tea shops. It helps shop owners optimize time and save costs.'
    }
  ],
  appPermission: {
    title: 'App access',
    photo: {
      title: 'Photo access',
      detail: 'The app requires access to photos on the device to update profile pictures, products, customers...'
    },
    camera: {
      title: 'Camera access',
      detail: 'The app requires access to the camera on the device to take photos for profile pictures, products, customers...'
    },
    bluetooth: {
      title: 'Bluetooth access',
      detail: 'The app requires Bluetooth access to connect to the printer via Bluetooth.'
    },
    notification: {
      title: 'Notification access',
      detail: 'The app requires notification access to update the latest information about the services you use.'
    }
  },
  orderTemplate: {
    title: 'Sample invoice',
    save: 'Save template',
    list: 'Sample invoice',
    saved: 'Sample saved successfully!',
    name: 'Remember name',
    nameWarning: 'Please enter a reminder name of more than 3 characters',
    delete: 'Delete sample order',
    deleteConfirm: 'Are you sure you want to delete this sample order?',
    hint: 'Sample orders help you create similar orders quickly. Press and hold to delete the sample'
  },
  printSetting2: {
    manualEnterIP: 'Manual IP input',
    bill: 'Receipt printer',
    billDetail: 'Thermal printer used to print sales invoices. Supports ESC/POS protocol',
    label: 'Label printer (sticker)',
    labelDetail: 'Thermal printer used to print product stickers. Supports ZPL, EPL, TSPL, DPL, CPCL... protocols',
    scan: 'Scan',
    rescan: 'Search again',
    connect: 'Connect',
    disconnect: 'Cancel connection',
    connected: 'Connected',
    scanning: 'Searching',
    disconnectConfirm: 'Are you sure you want to disconnect from this printer?',
    printerNotFound: 'No other printers found!',
    sunmiConnectError: 'Unable to connect to Sunmi printer. Please check your device!',
    usbConnectError: 'Unable to connect to USB printer. Please check your device!',
    sunmiDevice: 'Sunmi devices POS',
    labelPrinter: 'Label Printer',
    billPrinter: 'Receipt Printer',
    chooseConnectionAndDevice: 'Please select a connection type and device below',
    chooseWifiOrUsbForLabel: 'Please select Wifi or USB below to connect the printer',
    printProtocol: 'Print protocol:',
    blankLinesAfterBill: 'Blank spaces after printing bill',
    threshold: 'Print darkness (Threshold)',
    thresholdDetail: 'Adjust the darkness of the text',
    testPrint: 'Test print',
    alignContent: 'Align content to the left/right'
  },
  eInvoice: {
    intro: 'Set up a connection to the e-invoice provider and configure e-invoice issuance',
    title: 'E-invoice',
    setting: 'E-invoice settings',
    provider: 'E-invoice provider',
    addConnect: 'Add connection',
    updateConnect: 'Edit connection',
    reconnect: 'Reconnect',
    disconnect: 'Cancel connection',
    disconnectWarning: 'After disconnecting, you will not be able to create and access e-invoices from this provider. Are you sure you want to disconnect from this provider?',
    account: 'Account',
    userName: 'E-invoice system login name',
    password: 'Password',
    passwordDetail: 'E-invoice system login password',
    linkApi: 'API server link',
    confirm:
      'By clicking save. You have agreed to allow the aSeller sales management system to help me transmit/receive invoices from aSeller to the e-invoice provider that I have chosen.',
    taxCode: 'Tax code',
    taxCodeDetail: 'Tax code of the enterprise or business household',
    settingForEInvoice: 'Set up e-invoice issuance (e-invoice)',
    allowPublish: 'Allow e-invoice issuance',
    autoPublish: 'Automatically issue e-invoice',
    invoiceType: 'Invoice type',
    invoiceTypeData: ['Value added tax invoice', 'Cash register invoice'],
    invoiceTemSeri: 'Invoice template and symbol',
    info: 'Type of invoice issued',
    export: 'Issuing e-invoice',
    infoDefaultHint: 'Default invoice type issued when creating an order',
    deleteInfoConfirm: 'Are you sure you want to delete this invoice template no?',
    addInfo: 'Add invoice type',
    updateInfo: 'Edit invoice',
    infoName: 'Invoice name',
    infoNameIsShort: 'Invoice name is too short',
    templateInvalid: 'Invoice template and symbol are invalid',
    sellerInfo: 'Seller information on e-invoice',
    sellerInfoIntro: 'If left blank, the system will get store information on aSeller',
    sellerName: 'Seller name',
    sellerAddress: 'Seller address',
    sellerEmail: 'Seller email address',
    sellerPhone: 'Seller phone number',
    sellerBankName: 'Bank name',
    sellerBankAccount: 'Bank account number',
    invalidField: 'Please enter full valid information',
    unauthorized: 'Invalid connection information. Please check your account and password!',
    active: 'Enable electronic invoice issuance',
    auto: 'Automatically issue electronic invoices',
    autoHint: "Each time a sales order is saved, the system will automatically transmit it to the linked electronic invoice provider's system",
    showOnBill: 'Display electronic invoice lookup information on the sales invoice',
    activeForOrderNotPay: 'Enable electronic invoice issuance for all orders',
    activeForOrderNotPayHint: 'When deactivated, only paid orders will issue electronic invoices',
    invoiceNo: 'Invoice number',
    transactionID: 'Transaction code',
    codeOfTax: 'CQT code',
    reservationCode: 'Lookup code',
    download: 'Download file',
    checkLink: 'Look up electronic invoices at',
    create: 'Issue electronic invoices',
    createWarning: 'Are you sure you want to issue Is this order invoice issued?',
    createAllWarning: 'Are you sure you want to issue an invoice for the selected %s orders?',
    tryAgain: 'Reissue',
    creating: 'Issuing invoice',
    createError: 'Issuing error',
    reconciliation: 'Reconcile invoice',
    createSuccess: 'Issued successfully',
    search: 'Enter invoice number, CQT code, search code',
    providerHint:
      'You need to register for the service from the electronic invoice provider and be granted an account to be able to issue electronic invoices. If you do not have an account, please contact support for instructions on registering for the service.',
    emptyEInfoWarning: 'Please add invoice type first',
    emptyEConnectWarning: 'Please add supplier connection first',
    notSupportEditWarning: "Note: aSeller does not support editing e-invoices after they have been issued. To edit an order, please edit it in the e-invoice provider's system.",
    autoSign: 'Automatically digitally sign and send to the tax authority',
    autoSignDetail:
      'Electronic invoices generated will be automatically digitally signed and sent to the tax authority. If this function is turned off, shops will need to manually sign the invoices before they can be sent to the tax authority',
    notSign: 'Unsigned',
    manualSign: 'Sign invoice',
    manualSignWarning:
      'Are you sure you want to sign this invoice? After signing, the invoice will be sent to the tax authority. aSeller does not support editing issued electronic invoices'
  },
  servicesSetting: {
    slot: 'Capacity',
    prefix: 'Prefix name',
    prefixDefault: 'Table',
    prefixEx: 'Ex: Table, room...',
    title: 'Service interface settings',
    area: 'Area',
    areaName: 'Area name',
    editArea: 'Edit area',
    addArea: 'Add area',
    list: 'Service list',
    editName: 'Edit service name',
    addAreaHint: 'New sales areas can be added in Settings - Store Settings',
    stopAreaActive: 'Deactivate area',
    stopAreaActiveWarning: 'Are you sure you want to deactivate this area?',
    notFoundArea: 'There is no area yet. Please create a new area in your store settings.'
  },
  billSetting: {
    qrMoney: 'QR code amount',
    qrMoneyDetail: 'Optional amount to display on QR code. Can be total customer debt or order amount',
    qrMoneyType: ['Total customer debt', 'Order amount']
  },
  stats: {
    contributionByStaff: 'Contribution by staff',
    summaryByStaff: 'Summary by staff',
    saleByStaff: 'Sales by staff',
    revenue: 'Revenue',
    overview: 'Business results',
    productReport: 'Products report',
    orderCount: 'Total orders',
    cashflow: 'Cash flow',
    cashInflow: 'Cash inflow',
    cashOutflow: 'Cash outflow',
    remainingCash: 'Remaining cash flow',
    netCash: 'Net cash flow',
    return: 'Refund',
    customerAndSuppliers: 'Customers & Suppliers',
    salesChart: 'Revenue chart',
    cashflowInThisMonth: 'Cash flow this month',
    cashflowIn30Days: 'Cash flow last 30 days',
    openBalance: 'Opening balance',
    openBalanceDetail:
      'Opening Balance is the total balance (Cash Inflow - Cash Outflow) from the beginning of the operation to the beginning of the period. \nExample: The time you choose is this month, then Opening Balance is the balance from before the 1st of the month',
    orderFee: 'Order Fees',
    orderFeeChart: 'Order Fee Chart',
    orderFeeDetails: 'Fee Details by Date',
    totalVat: 'VAT',
    totalSurcharge: 'Surcharge',
    totalSurchargeByCustomer: 'Surcharge by Customer',
    totalSurchargeByShop: 'Surcharge by Shop'
  },
  saleCounter: {
    weekChart: 'Weekly Chart',
    invoice: 'INVOICE',
    paymentSuccess: 'Payment successful!',
    error: 'Error',
    selectVariant: 'Please select a variant'
  },
  screenText: {
    staffLogin: {
      subtitle: 'Welcome back, Staff member!',
      backToOwnerLogin: 'Back to business owner login'
    },
    activeVoucher: {
      selectStaff: 'Select staff',
      selectWarehouse: 'Select warehouse',
      requireStaff: 'Please select staff to update package!',
      requireWarehouse: 'Please select extended warehouse to update package!'
    },
    setting: {
      generalSubtitle: 'Manage language and primary currency unit.',
      currencyDescription: 'Currency symbol displayed in reports.',
      prefixSubtitle: 'Configure code prefixes for orders and vouchers.',
      homeSubtitle: 'Customize information shown on the Dashboard home.',
      aboutSubtitle: 'Version details and technical support.',
      aboutAppName: 'aSeller Sales Management',
      aboutAppDesc: 'Professional sales solution for small businesses.'
    },
    shopSetting: {
      noWebsite: 'The system has not created a Website for your store yet.',
      vipExpired: 'Pro account has expired',
      vipDuration: 'VIP+ package duration',
      themeSampleTitle: 'Theme templates',
      themeSample1: 'Template 1',
      themeSample2: 'Template 2',
      advancedSubtitle: 'Manage advanced display features of the Website.'
    },
    eInvoiceSetting: {
      tabConnect: 'Connection',
      tabSettings: 'Configuration',
      connectTitle: 'E-invoice Connection',
      settingsTitle: 'System Configuration',
      settingsSubtitle: 'Configure auto invoice issuance and display information.'
    },
    invoiceSetting: {
      bankTab: 'Bank Account',
      invoiceSubtitle: 'Configure display information and options for sales invoices.',
      bankInfoTitle: 'Bank Information',
      bankInfoSubtitle: 'Configure QR code and account information for bank transfer payments.',
      bankQrTitle: 'Bank QR code',
      noBankQr: 'No QR code yet',
      vietQrBankTitle: 'VietQR Bank Account'
    },
    orderSetting: {
      orderSubtitle: 'Configure order handling flow and sales information display.',
      debtSubtitle: 'Manage customer debt and debt records on invoices.',
      hourlySubtitle: 'Set up time-based service billing (e.g., billiards, karaoke hours...).',
      extraTitle: 'Utilities & Surcharges',
      extraSubtitle: 'Set up additional services and automatic surcharges for orders.'
    },
    pointSetting: {
      subtitle: 'Configure the loyalty point and redemption system for customers.'
    },
    detail: {
      basicInfo: 'Basic information',
      attributesAndManagement: 'Attributes & Management',
      attributesAndTax: 'Attributes & Tax',
      groupInfo: 'Group information'
    },
    detailCustomer: {
      changePasswordDetail: 'Change the login password for this customer account',
      passwordMinLength: 'Password must be longer than 4 characters!'
    },
    customer: {
      taxCodeNotFound: 'Tax code information not found'
    },
    receipt: {
      reason: 'Reason',
      treasurer: 'Treasurer',
      payer: 'Payer',
      creator: 'Voucher creator',
      signNameHint: '(Sign, full name)'
    },
    dashboard: {
      top1BestSeller: '#1 BEST SELLER',
      noData: 'No data',
      noDataHint: 'Add products to display this statistic'
    },
    uploader: {
      chooseImageFile: 'Choose image file',
      chooseExcelFile: 'Choose Excel file'
    }
  },
  shipping: {
    title: 'Shipping',
    subtitle: 'Configure shipping providers and delivery methods',
    info: 'Shipping Information',
    infoDetail: 'Completely separate from the current order status.',
    infoSub: 'Manage shipping status, tracking, and delivery information.',
    noActive: 'No active shipping label',
    noActiveDetail: 'Initialize shipping after the order has a delivery address and recipient.',
    create: 'Create Shipping',
    bulkCreate: 'Create Bulk Shipping',
    bulkCreateConfirm: 'Are you sure you want to create shipping labels for %s orders with %s?',
    bulkCreateSuccess: 'Successfully created shipping labels for %s orders.',
    bulkCreatePartial: 'Created shipping labels for %s orders, %s orders failed.',
    bulkCreateFailed: 'Bulk shipping creation failed.',
    createHint: 'You can create a manual shipment or call the provider API when the provider is configured.',
    createMode: 'Create Mode',
    createModeHintManual: 'Create the internal shipment and allow manual tracking code input.',
    createModeHintProvider: 'Call the provider API to create the shipment and receive the tracking code automatically.',
    providerModeUnavailable: 'This provider is not configured for API shipment creation yet, manual mode will be used.',
    providerCodeAutoGenerated: 'The tracking code will be returned by the provider after a successful API call.',
    providerCreateFailed: 'Could not create shipment from provider, internal shipment was not saved.',
    providerEstimateFailed: 'Could not estimate shipping fee from provider.',
    estimateFee: 'Estimate Provider Fee',
    feeEstimated: 'Shipping fee updated from provider.',
    reCreate: 'Re-create',
    update: 'Update',
    updateStatus: 'Update Status',
    updateInfo: 'Edit Shipping Info',
    updateInfoTitle: 'Update Shipping Information',
    updateInfoHint: 'Allows editing the tracking code, tracking URL, provider status, and note without changing the internal shipping status.',
    updateStatusTitle: 'Update Shipping Status',
    updateStatusHint: 'Only use internal shipping statuses, does not affect the old Orders.status dropdown.',
    cancel: 'Cancel Shipping',
    cancelConfirm: 'Are you sure you want to cancel this shipping label?',
    cancelWarning: 'This action cannot be undone.',
    irregularTransitionConfirm: 'The selected status is not in the normal processing flow. Are you sure you want to update?',
    status: 'Shipping Status',
    newStatus: 'New Status',
    message: 'Message',
    note: 'Note',
    tracking: 'Tracking',
    trackingCode: 'Tracking Code',
    trackingUrl: 'Tracking URL',
    openTracking: 'Open tracking link',
    provider: 'Shipping Provider',
    providerStatusLabel: 'Provider Status',
    providerRequired: 'Please select a shipping provider.',
    providers: 'Shipping Providers',
    providersDetail: 'Configure GHN/GHTK/J&T/Viettel Post with explicit form fields. Raw JSON stays in the advanced area for dev/support only.',
    addConfig: 'Add Config',
    editConfig: 'Edit Config',
    saveConfigTitle: 'Save Provider Configuration',
    saveConfig: 'Save Configuration',
    displayName: 'Display Name',
    webhookSecret: 'Webhook Secret',
    notConfigured: 'Not configured',
    credentials: 'Credentials',
    credentialsJson: 'Credentials (JSON)',
    invalidCredentialsJson: 'Invalid credentials JSON',
    invalidProviderConfigJson: 'Credentials or settings JSON is invalid',
    providerSettings: 'Provider Settings',
    providerSettingsJson: 'Provider Settings (JSON)',
    providerConfigGuide: 'Suggested fields by provider',
    providerAccountInfo: 'Provider Account Information',
    providerConfigFromAccount: 'These values come from GHN/GHTK/J&T/Viettel Post accounts or the shop pickup warehouse information.',
    manualConfigDescription: 'Use this when the shop already has an external tracking code and wants to enter it manually. No token or API settings are required.',
    providerSummary: 'Configuration Summary',
    token: 'Token',
    newToken: 'New Token',
    newTokenPlaceholder: 'Enter a new token only if you want to replace the current one',
    tokenConfigured: 'Configured',
    tokenNotConfigured: 'Not configured',
    configured: 'Configured',
    environment: 'Environment',
    environmentList: {
      sandbox: 'Sandbox',
      production: 'Production'
    },
    autoMappedBaseUrl: 'Auto-mapped API URL',
    customBaseUrl: 'Custom baseUrl',
    serviceTypeId: 'Default Service Type',
    paymentTypeId: 'Default Payer',
    paymentTypeList: {
      shop: 'Shop Pays',
      customer: 'Customer Pays'
    },
    shopId: 'Shop ID',
    partnerCode: 'Partner Code',
    customerCode: 'Customer Code',
    jtApiKey: 'J&T API Key',
    viettelUsername: 'Viettel Username',
    viettelPassword: 'Viettel Password',
    viettelCredential: 'Viettel token or account',
    originCode: 'Origin code',
    destinationCode: 'Destination code',
    receiverArea: 'Receiver area code',
    orderPrefix: 'Order code prefix',
    createEndpoint: 'Create endpoint',
    trackEndpoint: 'Tracking endpoint',
    payloadKey: 'Tracking payload key',
    pickupWarehouseInfo: 'Pickup Warehouse Information',
    pickupWarehouseHint: 'Enter the warehouse or shop pickup information used by GHTK for automatic shipment creation.',
    jtSenderHint: 'J&T requires complete sender information for API shipment creation.',
    viettelSenderHint: 'Viettel Post requires complete sender information; you can use either token or username/password.',
    pickupName: 'Pickup Warehouse Name',
    pickupPhone: 'Pickup Warehouse Phone',
    pickupAddress: 'Pickup Warehouse Address',
    pickupProvince: 'Pickup Province',
    pickupDistrict: 'Pickup District',
    pickupWard: 'Pickup Ward',
    ghnProvince: 'Province (GHN)',
    ghnDistrict: 'District (GHN)',
    ghnWard: 'Ward (GHN)',
    ghnAddressHint: 'Please select a standard GHN address to create a shipment.',
    ghnMasterDataError: 'Error fetching GHN address data. Please try again.',
    advancedSettings: 'Advanced',
    advancedSettingsHint: 'Only use when you need to override the baseUrl or enter raw JSON for dev/support.',
    credentialsJsonAdvanced: 'Credentials JSON (Advanced)',
    providerSettingsJsonAdvanced: 'Settings JSON (Advanced)',
    requiredFieldMissing: 'Please configure %s before saving.',
    hasData: 'Has data',
    empty: 'Empty',
    none: 'None',
    activeThisProvider: 'Activate this provider',
    code: 'Tracking Code',
    receiver: 'Receiver',
    phone: 'Phone Number',
    address: 'Delivery Address',
    fee: 'Shipping Fee',
    cod: 'COD Amount',
    lastWebhook: 'Last Webhook',
    notUpdate: 'Not updated',
    timeline: 'Shipping Timeline',
    history: 'Shipping Timeline',
    timelineDetail: 'Update history from webhook or manual operations.',
    noLogs: 'No shipping logs yet.',
    waitSync: 'Waiting for sync',
    updateHint: 'Updated shipping status.',
    currentStatusHint: 'Current status of the shipping label.',
    updatedBy: 'Updated by',
    statusList: {
      none: 'Not created',
      draft: 'Draft',
      awaiting_pickup: 'Awaiting pickup',
      pickup_in_progress: 'Pickup in progress',
      picked_up: 'Picked up',
      sorting: 'Sorting',
      in_transit: 'In transit',
      out_for_delivery: 'Out for delivery',
      delivered: 'Delivered',
      delivery_failed: 'Delivery failed',
      canceled: 'Canceled',
      return_requested: 'Return requested',
      return_in_transit: 'Returning',
      returned: 'Returned',
      exception: 'Exception'
    },
    providerList: {
      manual: 'Manual',
      manualDetail: 'Enter and update manually',
      ghn: 'GHN',
      ghnDetail: 'GHN API integration',
      ghtk: 'GHTK',
      ghtkDetail: 'GHTK API integration',
      jt: 'J&T Express',
      jtDetail: 'J&T API integration',
      viettel_post: 'Viettel Post',
      viettel_postDetail: 'Viettel Post API integration'
    },
    createModeList: {
      manual: 'Manual Create',
      provider: 'Create via Provider'
    },
    configFieldLabels: {
      token: 'Token',
      environment: 'Environment',
      baseUrl: 'API URL',
      serviceTypeId: 'Default Service Type',
      paymentTypeId: 'Default Payer',
      webhookSecret: 'Webhook Secret',
      shopId: 'Shop ID',
      key: 'J&T API Key',
      customerCode: 'Customer Code',
      username: 'Viettel Username',
      password: 'Viettel Password',
      originCode: 'Origin code',
      destinationCode: 'Destination code',
      receiverArea: 'Receiver area code',
      pickupName: 'Pickup Warehouse Name',
      pickupPhone: 'Pickup Warehouse Phone',
      pickupAddress: 'Pickup Warehouse Address',
      pickupProvince: 'Pickup Province',
      pickupDistrict: 'Pickup District',
      pickupWard: 'Pickup Ward'
    }
  }
};
